function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
  
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
  
  const trapFocusHandlers = {};
  
  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
  
    removeTrapFocus();
  
    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;
  
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.focusout = function() {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
  
      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };
  
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
  
    elementToFocus.focus();
  
    if (elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
  
  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
    document.querySelector(":focus-visible");
  } catch(e) {
    focusVisiblePolyfill();
  }
  
  function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;
  
    window.addEventListener('keydown', (event) => {
      if(navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });
  
    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });
  
    window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
  
      if (mouseClick) return;
  
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
  
    }, true);
  }
  
  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
  
  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
    if (elementToFocus) elementToFocus.focus();
  }
  
  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
  
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
  
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }
  
class QuantityInput extends HTMLElement 
{
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('keyup', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    this.RunInputChange( );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    this.validateQtyRules( );
    RunCartQuantityChange( this, event.target.name, this.input.value );
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      // buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  // NOTE : this only works for ONE TIME PURCHASES !
  RunInputChange( )
  {
      var form = this.input.form;
      var formVariant;
      var element;
      
      if ( form )
      {
          element = form;
          formVariant = form.querySelector( ".product-variant-id" ).value;
      }
      else
      {
          element = this.closest( "quantity-input" );
          formVariant = element.getAttribute( "data-variant-id" );
      }

      if ( formVariant )
      {
          var cartInputs = document.querySelectorAll( ".cart-drawer-items-container .we_cart_item[ data-variant-id='"+ formVariant +"' ] input[type='number']" );
          if ( cartInputs )
          {
              for ( var i = 0; i < cartInputs.length; i++ )
              {
                  var cartInput = cartInputs[ i ];
                  var item      = cartInput.closest( ".we_cart_item" );
                  var spid      = item.getAttribute( "data-selling-plan-id" );
                  //console.log( "got spid " + spid  + " from ", item );
                  if ( spid )
                  {
                      // currently ignoring subscription items in the cart
                  }
                  else
                  {
                      //console.log( "set qty " + this.input.value + " on ", cartInput );
                      cartInput.value = this.input.value;
                      var event = new Event( "keyup" );
                      cartInput.dispatchEvent( event );
                      break;
                  }
              }
          }
      }
      else
      {
          console.log( "error - unsupported qty selector dom" );
      }
  }
}

function RunCartQuantityChange( item, qtyType, qtyInputValue )
{
    //console.log( "cart qty change for ", item );
    
    //nasty !
    var form = item.input.form;
    var formVariant;
    var element;
    
    if ( form )
    {
        element = form;
        formVariant = form.querySelector( ".product-variant-id" ).value;
    }
    else
    {
        element = item.closest( "quantity-input" );
        formVariant = element.getAttribute( "data-variant-id" );
    }

    if ( formVariant )
    {
        var cartQtyButton = document.querySelector( ".cart-drawer-items-container .we_cart_item[ data-variant-id='"+ formVariant +"' ]:not([data-selling-plan-id]) .cart-quantity-value-change[data-type='" + qtyType + "']" );

        //console.log( "disable cart qty control ", element );
        // element.setAttribute( "disabled", "disabled" );
        // element.classList.add( "disabled" );
        
        cartQtyButton.click();

        

        // 20241209: disabling this, new handling in custom.js is more reliable
        //if( qtyInputValue == "1" && qtyType == "minus" )
        //{
        //    console.log( "run decrement" );
        //    HandleFormButtonDisplay( form, "hide" );
        //}
        //else if( qtyInputValue == 1 && qtyType == "plus" )
        //{
        //    console.log( "run increment" );
        //    HandleFormButtonDisplay( form, "show" );
        //}
    }
    else
    {
        console.log( "error - unsupported qty selector dom" );
    }
}
  
  customElements.define('quantity-input', QuantityInput);
  
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  
  /*
   * Shopify Common JS
   *
   */
  if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
  }
  
  Shopify.bind = function(fn, scope) {
    return function() {
      return fn.apply(scope, arguments);
    }
  };
  
  Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
  };
  
  Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
  };
  
  Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
  
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
  
    for(var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  
  Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));
  
    this.initCountry();
    this.initProvince();
  };
  
  Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
      var value = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
    },
  
    initProvince: function() {
      var value = this.provinceEl.getAttribute('data-default');
      if (value && this.provinceEl.options.length > 0) {
        Shopify.setSelectorByValue(this.provinceEl, value);
      }
    },
  
    countryHandler: function(e) {
      var opt       = this.countryEl.options[this.countryEl.selectedIndex];
      var raw       = opt.getAttribute('data-provinces');
      var provinces = JSON.parse(raw);
  
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = 'none';
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement('option');
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }
  
        this.provinceContainer.style.display = "";
      }
    },
  
    clearOptions: function(selector) {
      while (selector.firstChild) {
        selector.removeChild(selector.firstChild);
      }
    },
  
    setOptions: function(selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement('option');
        opt.value = values[i];
        opt.innerHTML = values[i];
        selector.appendChild(opt);
      }
    }
  };
  
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.mainDetailsToggle = this.querySelector('details');
  
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
  
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
  
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
  
      const openDetailsElement = event.target.closest('details[open]');
      if(!openDetailsElement) return;
  
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
  
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.has-submenu');
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
  
      if (detailsElement === this.mainDetailsToggle) {
        if(isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
  
        if (window.matchMedia('(max-width: 990px)')) {
          document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        }
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
  
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  
    onFocusOut() {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
  
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  
    closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  
    closeAnimation(detailsElement) {
      let animationStart;
  
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
  
        const elapsedTime = time - animationStart;
  
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }
  
      window.requestAnimationFrame(handleAnimation);
    }
  }
  
  customElements.define('menu-drawer', MenuDrawer);
  
  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }
  
    openMenuDrawer(summaryElement) {
      this.header = this.header || document.querySelector('.section-header');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
      this.header.classList.add('menu-open');
  
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
  
      summaryElement.setAttribute('aria-expanded', true);
      window.addEventListener('resize', this.onResize);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus) {
      if (!elementToFocus) return;
      super.closeMenuDrawer(event, elementToFocus);
      this.header.classList.remove('menu-open');
      window.removeEventListener('resize', this.onResize);
    }
  
    onResize = () => {
      this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };
  }
  
  customElements.define('header-drawer', HeaderDrawer);
  
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }
    }
  
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
  
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }
  
    hide() {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }
  customElements.define('modal-dialog', ModalDialog);
  
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
  
      const button = this.querySelector('button');
  
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
  
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  
    loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
  
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  }
  
  customElements.define('deferred-media', DeferredMedia);
  
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;
  
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
  
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  
    update() {
      // Temporarily prevents unneeded updates resulting from variant changes
      // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
      if (!this.slider || !this.nextButton) return;
  
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
  
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }
  
      if (this.enableSliderLooping) return;
  
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
  
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  
  customElements.define('slider-component', SliderComponent);
  
  class SlideshowComponent extends SliderComponent {
    constructor() {
      super();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;
  
      if (!this.sliderControlWrapper) return;
  
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
  
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
  
    setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;
  
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));
  
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }
  
    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
  
      if (!isFirstSlide && !isLastSlide) return;
  
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  
    update() {
      super.update();
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');
  
      if (!this.sliderControlButtons.length) return;
  
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  
    autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
  
    focusOutHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    }
  
    focusInHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }
  
    play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
  
    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }
  
    togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }
  
    autoRotateSlides() {
      const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  
    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const linkElements = item.querySelectorAll('a');
        if (index === this.currentPage - 1) {
          if (linkElements.length) linkElements.forEach(button => {
            button.removeAttribute('tabindex');
          });
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (linkElements.length) linkElements.forEach(button => {
            button.setAttribute('tabindex', '-1');
          });
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }
  
    linkToSlide(event) {
      event.preventDefault();
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  
  customElements.define('slideshow-component', SlideshowComponent);
  
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
      document.querySelector( "product-info" ).dataset.variantUrl = document.querySelector( "variant-radios input:checked" ).dataset.variantUrl;
      document.querySelector( "product-info" ).dataset.variantPrice = document.querySelector( "variant-radios input:checked" ).dataset.variantPrice;
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
  
      const activeMedia = this.currentVariant.featured_media.id;
      document.querySelector( `.product-media-main-item.is-active` )?.classList.remove( "is-active" );
      document.querySelector( `.product-media-main-item[data-media-id="${this.dataset.section}-${activeMedia}"]` )?.classList.add( "is-active" );

      var productMediaMain = document.querySelector('.product-media-main');
      if ( productMediaMain.classList.contains( "slick-initialized" ) )
      {
        productMediaMain.slick.slickGoTo( document.querySelector( `.product-media-main-item[data-media-id="${this.dataset.section}-${activeMedia}"]` ).dataset.slickIndex );
      }
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
      });
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.innerText = input.getAttribute('value');
        } else {
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        }
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
  
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;
  
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const priceDestination = document.getElementById(`price-${this.dataset.section}`);
          const priceSource = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
  
          if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          }
  
          if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
  
          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
  
          publish(PUB_SUB_EVENTS.variantChange, {data: {
            sectionId,
            html,
            variant: this.currentVariant
          }});
        });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
      const sku = document.getElementById(`Sku-${this.dataset.section}`);
  
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
      if (inventory) inventory.classList.add('visibility-hidden');
      if (sku) sku.classList.add('visibility-hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-selects', VariantSelects);
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  
  customElements.define('variant-radios', VariantRadios);
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
  
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
  
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
  
            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }
  
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
  
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);

class CustomDatePicker extends HTMLElement
{
    constructor( )
    {
        super( );
    }

    connectedCallback( )
    {
        //bindings
        this.toggleCalendar = this.toggleCalendar.bind( this );
        this.goToPreviousMonth = this.goToPreviousMonth.bind( this );
        this.goToNextMonth = this.goToNextMonth.bind( this );
        this.selectDay = this.selectDay.bind( this );

        //elements
        this.modal = this.querySelector( ".js-cdp-modal" );
        this.toggles = this.querySelectorAll( ".js-cdp-toggle" );
        this.prevMonthBtn = this.querySelector( ".js-cdp-month-prev" );
        this.nextMonthBtn = this.querySelector( ".js-cdp-month-next" );
        this.monthText = this.querySelector( ".js-cdp-month" );
        this.rows = this.querySelector( ".js-cdp-rows" );
        this.rowTemplate = this.querySelector( ".js-cdp-row--template" );
        this.dayTemplate = this.querySelector( ".js-cdp-day--template" );

        //variables
        this.today = new Date( );
        this.shownMonth = new Date( );
        this.selectedDate = new Date( );
        this.tempSelected = new Date( );
        this.days =
        [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
        ]
        this.months =
        [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        this.options =
        {
            weekday: "long"
        };
        this.formatter = new Intl.DateTimeFormat("en-US", this.options );
        this.dayValue = 60 * 60 * 26;

        //eventlisteners
        this.toggles.forEach( toggle =>
        {
            toggle.addEventListener( "click", this.toggleCalendar );
        });

        this.prevMonthBtn.addEventListener( "click", this.goToPreviousMonth );
        this.nextMonthBtn.addEventListener( "click", this.goToNextMonth );

        this.renderMonthView( this.shownMonth.getMonth( ), this.shownMonth.getFullYear( ) );

        //console.log( this.today );
    }

    toggleCalendar( )
    {
        if ( this.modal.classList.contains( "cdp__modal--active" ) )
        {
            this.modal.classList.remove( "cdp__modal--active" );
            this.modal.ariaExpanded = false;
        }
        else
        {
            this.modal.classList.add( "cdp__modal--active" );
            this.modal.ariaExpanded = true;
        }
    }

    goToPreviousMonth( )
    {
        this.shownMonth.setMonth( this.shownMonth.getMonth( ) - 1 );
        this.renderMonthView( this.shownMonth.getMonth( ), this.shownMonth.getFullYear( ) );
    }

    goToNextMonth( )
    {
        this.shownMonth.setMonth( this.shownMonth.getMonth( ) + 1 );
        this.renderMonthView( this.shownMonth.getMonth( ), this.shownMonth.getFullYear( ) );
    }

    renderMonthView( month, year )
    {
        var oldRows = document.querySelectorAll( ".js-cdp-row" );
        oldRows.forEach( row =>
        {
            row.remove( );
        })

        var daysInMonth = new Date( year, month + 1, 0 ).getDate( );
        var firstOfMonth = new Date( year, month, 1 );
        var lastOfMonth = new Date( year, month + 1, 0 );
        
        var daysToAddBefore = this.days.indexOf( this.formatter.format( firstOfMonth ) );
        var daysToRender = [ ];
        for ( var i = 0; i < daysToAddBefore; i ++ )
        {
            var offset = daysToAddBefore - i;
            var tempDate = new Date( firstOfMonth );
            tempDate.setDate( tempDate.getDate( ) - offset );
            daysToRender.push( { day: tempDate.getDate( ), month: tempDate.getMonth( ), year: tempDate.getFullYear( ) } );
        }

        for ( var i = 0; i < daysInMonth; i ++ )
        {
            var day = i + 1;
            daysToRender.push( { day: day, month: firstOfMonth.getMonth( ), year: firstOfMonth.getFullYear( ) } );
        }

        var remainingDaysToAdd = 7 - ( daysToRender.length % 7 );
        if ( remainingDaysToAdd == 7 )
        {
            remainingDaysToAdd = 0;
        }

        for ( var i = 0; i < remainingDaysToAdd; i ++ )
        {
            var offset = i + 1;
            var tempDate = new Date( lastOfMonth );
            tempDate.setDate( tempDate.getDate( ) + offset );
            daysToRender.push( { day: tempDate.getDate( ), month: tempDate.getMonth( ), year: tempDate.getFullYear( ) } );
        }

        daysToRender.forEach( ( day, index ) =>
        {
            var dayElement = this.dayTemplate.cloneNode( );
            var rowElement = this.rowTemplate.cloneNode( false );

            var rowNumber = Math.floor( index / 7 ) + 1;
            
            var rows = this.rows.querySelectorAll( ".js-cdp-row" );
            if ( rows.length < rowNumber )
            {
                rowElement.classList.remove( "js-cdp-row--template" )
                rowElement.classList.remove( "calendar__picker__row--template" );
                rowElement.classList.add( "js-cdp-row" )
                this.rows.appendChild( rowElement );
                rows = this.rows.querySelectorAll( ".js-cdp-row" );
            }

            var rowToInsertIn = rows[ rowNumber - 1 ];
            dayElement.classList.remove( "js-cdp-day--template" );
            dayElement.classList.add( "js-cdp-day" );

            if ( firstOfMonth.getMonth() != day.month )
            {
                dayElement.classList.add( "row__day--oob" );
                dayElement.disabled = true;
            }
            if ( this.today.getMonth( ) == day.month && this.today.getDate( ) == day.day && this.today.getFullYear( ) == day.year )
            {
                dayElement.classList.add( "row__day--today" );
            }

            dayElement.textContent = day.day;
            rowToInsertIn.appendChild( dayElement );
        });

        this.monthText.textContent = `${ this.months[ firstOfMonth.getMonth( ) ] } ${ firstOfMonth.getFullYear( ) }`;
    }

    setDayEventListeners( )
    {
        var days = this.querySelectorAll( ".js-cdp-day" );
        days.addEventListener( "click", this.selectDay );
    }

    selectDay( )
    {
        //to be added,
    }
}

customElements.define( "custom-date-picker", CustomDatePicker );

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// moved from inline script in component-product-quantity.liquid
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// document.addEventListener('DOMContentLoaded', function () 
// {
//     var quantityInputs = document.querySelectorAll('quantity-input');

//     // to do : what if it takes longer than 500ms to change the product quantity ? FIXME !!
//     quantityInputs.forEach(wrapper => 
//     {
//         var plusBtn = wrapper.querySelector('button[name="plus"]');
//         var minusBtn = wrapper.querySelector('button[name="minus"]');

//         var disableButtonsTemporarily = () => 
//         {
//             plusBtn.disabled = true;
//             minusBtn.disabled = true;
//             setTimeout(() => 
//             {
//                 plusBtn.disabled = false;
//                 minusBtn.disabled = false;
//             }, 500);
//         };

//         plusBtn.addEventListener('click', disableButtonsTemporarily);
//         minusBtn.addEventListener('click', disableButtonsTemporarily);
//     });
// });
  


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// autoship banner
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function StartAutoshipBannerHandling( )
{
    function SetupAutoShipEvents( )
    {
        var buttons = document.querySelectorAll( ".autoship-banner-close" );
        buttons.forEach( function( button )
        {
            button.addEventListener( "click", function( e )
            {
                var popup = e.currentTarget.closest( ".autoship-banner" );
                if ( popup )
                {
                    popup.classList.add( "hidden" );
                }
            } );
        } );
    }

    window.addEventListener( "load", SetupAutoShipEvents );
}
StartAutoshipBannerHandling( );

function handleCustomLoyaltyContent( )
{
	var customContent = document.querySelector( "[data-custom-loyaly-content]" );
	var loyaltyContainer = document.querySelector( "[data-lion-integrated-page]" );

	if ( customContent && loyaltyContainer )
	{
		var headerTries = 0;
		var headerInterval = setInterval(function() 
		{
			headerTries ++;
			if ( loyaltyContainer.querySelector( ".lion-header__your-points" ) )
			{
				clearInterval( headerInterval );

        var points = customContent.querySelector(".custom-loyalty__point").textContent;
        points = points.replace(/[^\d]/g, "");
        points = parseInt(points, 10) || 0; 
        var pointsMoney = formatter.format(parseFloat(points / 100));
				var newHeader = customContent.querySelector( ".custom-loyalty__header" );
				newHeader.querySelector( ".text__cash-amount" ).textContent = pointsMoney;
				loyaltyContainer.querySelector( ".lion-header" ).insertAdjacentElement( "beforebegin", newHeader );
				loyaltyContainer.querySelector( ".lion-header__your-points" ).classList.add( "hidden" );
				loyaltyContainer.querySelector( ".lion-header__pending-points" ).classList.add( "hidden" );
			}
			else if ( faqsTries == 20 )
			{
				clearInterval( headerInterval );
			}
		}, 250 );

		var faqsTries = 0;
		var faqsInterval = setInterval(function() 
		{
			faqsTries ++;
			if ( loyaltyContainer.querySelector( ".lion-integrated-page" ) )
			{
				clearInterval( faqsInterval );
				var faqs = customContent.querySelector( ".custom-loyalty__faqs" );
				if ( loyaltyContainer.querySelector( ".lion-available-rewards" ) )
				{
					loyaltyContainer.querySelector( ".lion-available-rewards" ).insertAdjacentElement( "beforebegin", faqs );
				}
				else if ( loyaltyContainer.querySelector( ".lion-earn" ) )
				{
					loyaltyContainer.querySelector( ".lion-earn" ).insertAdjacentElement( "beforebegin", faqs );
				}
			}
			else if ( faqsTries == 20 )
			{
				clearInterval( checkInterval );
			}
		}, 250 );
	}
}

function initSecondaryNav( )
{
    var nav = document.querySelector( ".secondary-navigation-section" );
    if ( nav )
    {
        document.addEventListener( "scroll", function( )
        {
            if ( window.scrollY > 0 && window.innerWidth > 968 )
            {
                nav.classList.add( "secondary-navigation-section--fixed" );
            }
            else
            {
                nav.classList.remove( "secondary-navigation-section--fixed" );
            }
        });
    }
}

function initAutoshipNextOrderWidgets( )
{
	function widgetsCB( )
	{
		var widgets = document.querySelectorAll( ".next-autoship-order-widget-wrapper" );
		if ( rechargeData && rechargeData.charges && rechargeData.charges.length > 0 )
		{
			console.log( "Found charge" );

			var newestCharge = getNextRechargeCharge( rechargeData );

			widgets.forEach( widget =>
			{
				console.log( "Found widget" );

				var qty = 0;
				newestCharge.lines.forEach( line =>
				{
					qty += line.qty;
					
				});

				var qtyString;
				if ( qty == 1 )
				{
					qtyString = "1 item";
				}
				else if ( qty > 1 )
				{
					qtyString = qty + " items";
				}

				const chargeDate = new Date( newestCharge.at );
				const options = { weekday: 'long', month: 'long', day: 'numeric' };
				const formatted = new Intl.DateTimeFormat( 'en-US', options ).format( chargeDate );

				widget.querySelector( ".order__date" ).textContent = formatted;
				var count = parseInt(qtyString, 10) || 0;
        widget.querySelector(".naow__upper__count").textContent = (count - 1) + " items";

				widget.querySelector( ".u1" ).classList.remove( "hidden" );
				widget.querySelector( ".u2" ).classList.add( "hidden" );
			});
		}
	};

	console.log( "Initialising Autoship Widgets..." );

	var rechargeData;

	if ( window._autoshipData )
	{
		var rechargeData = window._autoshipData;
		widgetsCB( );
	}
	else 
    {
		console.log( "fetching" )
        FetchNextAutoshipOrder( function ( err, response )
        {
			window._autoshipData = response;
            rechargeData = response;
			widgetsCB( );
        });
    }
}

function wecEnsureNoFlickerStyle()
{
    if (document.getElementById('wec-noflicker-style'))
    {
        return;
    }
    var styleEl = document.createElement('style');
    styleEl.id = 'wec-noflicker-style';
    styleEl.textContent = '.js-wec-populate:not(.wec-ready){visibility:hidden}';
    document.head.appendChild(styleEl);
}

function wecHidePlaceholders()
{
    var nodes = document.querySelectorAll('.js-wec-populate');
    for (let i = 0; i < nodes.length; i++)
    {
        var node = nodes[i];
        node.classList.remove('wec-ready');
        if (!node.hasAttribute('data-wec-tpl'))
        {
            node.setAttribute('data-wec-tpl', node.innerHTML);
        }
    }
}

function wecFormatMoneyFromPoints(points)
{
    if (typeof formatter !== 'undefined')
    {
        return formatter.format(points / 100);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function')
    {
        return Shopify.formatMoney(points);
    }
    var val = (points / 100).toFixed(2);
    return '£' + val;
}

function wecStopPoll()
{
    var id = document.documentElement.dataset.wecPollId;
    if (id)
    {
        window.clearInterval(Number(id));
        delete document.documentElement.dataset.wecPollId;
    }
}

function wecStartPoll()
{
    wecStopPoll();
    let attempts = 0;
    var pollId = window.setInterval(function poll()
    {
        attempts = attempts + 1;
        var el = document.querySelector('.js-lion-points-amount');
        var text = '';
        if (el)
        {
            text = el.textContent.trim();
        }
        if (text.length === 0)
        {
            if (attempts > 60)
            {
                wecStopPoll();
            }
        }
        else
        {
            wecStopPoll();
            wecHydrate(text);
        }
    }, 250);
    document.documentElement.dataset.wecPollId = String(pollId);
}

function wecInitPlaceholdersOnce()
{
    if (document.documentElement.dataset.wecInitialized === '1')
    {
        return;
    }
    wecEnsureNoFlickerStyle();
    wecHidePlaceholders();
    document.documentElement.dataset.wecInitialized = '1';
}

function wecPointsChanged(newPoints)
{
    var last = document.documentElement.dataset.wecLastPoints;
    if (String(newPoints) === String(last))
    {
        return false;
    }
    document.documentElement.dataset.wecLastPoints = String(newPoints);
    return true;
}

function wecHydrate(rawText)
{
    var pointsText = rawText.replace(/[^\d]/g, '');
    var points = parseInt(pointsText, 10);
    if (isNaN(points))
    {
        points = 0;
    }
    if (!wecPointsChanged(points))
    {
        var already = document.querySelectorAll('.js-wec-populate');
        for (let k = 0; k < already.length; k++)
        {
            already[k].classList.add('wec-ready');
        }
        return;
    }
    var money = wecFormatMoneyFromPoints(points);
    var nodes = document.querySelectorAll('.js-wec-populate');
    for (let i = 0; i < nodes.length; i++)
    {
        var node = nodes[i];
        var tpl = node.getAttribute('data-wec-tpl') || node.innerHTML;
        var html = tpl.replace(/%points%/g, String(points)).replace(/%money%/g, String(money));
        node.innerHTML = html;
    }
    window.requestAnimationFrame(function reveal()
    {
        var toReveal = document.querySelectorAll('.js-wec-populate');
        for (let j = 0; j < toReveal.length; j++)
        {
            toReveal[j].classList.add('wec-ready');
        }
    });
    var guests = document.querySelectorAll('.welleasy-cash-widget.guest');
    var logged = document.querySelectorAll('.welleasy-cash-widget.logged-in');
    for (let g = 0; g < guests.length; g++)
    {
        guests[g].classList.add('hidden');
    }
    for (let l = 0; l < logged.length; l++)
    {
        logged[l].classList.remove('hidden');
    }
}

function populateWellEasyCash()
{
    wecInitPlaceholdersOnce();
    wecStartPoll();
}

function initWelleasyCashNoFlicker()
{
    wecInitPlaceholdersOnce();
    if (document.readyState === 'loading')
    {
        document.addEventListener('DOMContentLoaded', populateWellEasyCash);
    }
    else
    {
        populateWellEasyCash();
    }
    let wecCartDebounce;
    document.addEventListener('cart_item_added', function onCartItemAdded()
    {
        window.clearTimeout(wecCartDebounce);
        wecCartDebounce = window.setTimeout(function runPoll()
        {
            wecStartPoll();
        }, 100);
    });
}

function flipWECWidgetLink()
{
    var loggedInWidgets = document.querySelectorAll('.welleasy-cash-widget.guest');
    loggedInWidgets.forEach(function handleWidget(widget)
    {
        if (widget.scrollWidth > widget.offsetWidth)
        {
            widget.querySelector('.wcw__upper__link').classList.remove('visibility-hidden');
            widget.querySelector('.wcw__lower__link').classList.add('visibility-hidden');
        }
        else
        {
            widget.querySelector('.wcw__upper__link').classList.add('visibility-hidden');
            widget.querySelector('.wcw__lower__link').classList.remove('visibility-hidden');
        }
    });
}

window.addEventListener( "resize", flipWECWidgetLink );

function SetupManageOrderLink()
{
    var link    = document.querySelector(".manage-order-link");
    var modal   = document.querySelector(".autoship-manager");
    var closeBtn = document.querySelector(".autoship-manager-close");

    if (!link || !modal || !closeBtn)
    {
        return;
    }

    link.addEventListener("click", function(e)
    {
        e.preventDefault();
        modal.classList.add("autoship-manager--visible");
        closeBtn.classList.add("autoship-manager-close--visible");
    });
}

function SetupOrdersListScrollFix()
{
    var lists = document.querySelectorAll(
        ".cpo__orders-list__orders, .order__items"
    );

    if ( !lists || lists.length === 0 )
    {
        return;
    }

    lists.forEach( function( el )
    {
        el.addEventListener(
            "wheel",
            function( e )
            {
                var scrollable = e.target.closest(
                    ".cpo__order-details, .cpo__order, .order__items"
                );

                if ( scrollable && ( scrollable.scrollHeight > scrollable.clientHeight ) )
                {
                    var atTop    = scrollable.scrollTop === 0;
                    var atBottom = Math.ceil( scrollable.scrollTop + scrollable.clientHeight ) >= scrollable.scrollHeight;

                    // Allow native vertical scrolling if not at edges
                    if ( !( e.deltaY < 0 && atTop ) && !( e.deltaY > 0 && atBottom ) )
                    {
                        return;
                    }
                }

                if ( Math.abs( e.deltaY ) > Math.abs( e.deltaX ) )
                {
                    e.preventDefault();
                    e.stopPropagation();
                    window.scrollBy( 0, e.deltaY );
                }
            },
            { passive: false, capture: true }
        );
    } );
}

function initScrollers( )
{
    var scrollerContainers = document.querySelectorAll( ".js-scroller-container" );
    scrollerContainers.forEach( scrollerContainer =>
    {
        var track = scrollerContainer.querySelector( ".js-scroller-track" );
        if ( !track ) return;
        var scrollAmount = track.dataset.scrollAmount;
        var prevButtons = scrollerContainer.querySelectorAll( ".js-scroller-prev" );
        var nextButtons = scrollerContainer.querySelectorAll( ".js-scroller-next" );

        if ( !prevButtons || !nextButtons ) return;

        prevButtons.forEach( prevButton =>
        {
            prevButton.addEventListener( "click", function( e )
            {
                //prevent extra scrolling on ios caused by scrollAmount being too high on the edges of the parent element
                if ( track.scrollLeft > scrollAmount )
                {
                    track.scrollBy({ top: 0, left: -scrollAmount, behavior: "smooth" });
                }
                else
                {
                    track.scrollBy({ top: 0, left: -track.scrollLeft, behavior: "smooth" });
                }
            });
        });

        nextButtons.forEach( nextButton =>
        {
            nextButton.addEventListener( "click", function( e )
            {
                if ( track.scrollWidth - track.scrollLeft > scrollAmount  )
                {
                    track.scrollBy({ top: 0, left: scrollAmount, behavior: "smooth" });
                }
                else
                {
                    track.scrollBy({ top: 0, left: track.scrollWidth - track.scrollLeft, behavior: "smooth" });
                }
            });
        });
    });
}

function initHeroTextSliders( )
{
    var sections = document.querySelectorAll( ".hero-text-slider" );
    sections.forEach( section =>
    {
        var slider = section.querySelector( ".js-hero-slider" );

        if ( !slider ) return;

        $( slider ).slick(
        {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: `
            <div class="hts__slides__prev">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="js-hero-slider-prev">
                    <path d="M169.4 297.4C156.9 309.9 156.9 330.2 169.4 342.7L361.4 534.7C373.9 547.2 394.2 547.2 406.7 534.7C419.2 522.2 419.2 501.9 406.7 489.4L237.3 320L406.6 150.6C419.1 138.1 419.1 117.8 406.6 105.3C394.1 92.8 373.8 92.8 361.3 105.3L169.3 297.3z"/>
                </svg>
            </div>`,
            nextArrow: `
            <div class="hts__slides__next">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="js-hero-slider-next">
                    <path d="M471.1 297.4C483.6 309.9 483.6 330.2 471.1 342.7L279.1 534.7C266.6 547.2 246.3 547.2 233.8 534.7C221.3 522.2 221.3 501.9 233.8 489.4L403.2 320L233.9 150.6C221.4 138.1 221.4 117.8 233.9 105.3C246.4 92.8 266.7 92.8 279.2 105.3L471.2 297.3z"/>
                </svg>
            </div>`,
            draggable: true
        });
    });
}

function hideGiftPropertiesCart()
{
    var blocks = document.querySelectorAll('.cart-description');

    blocks.forEach(function(block)
    {
        var walker   = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, null);
        var toRemove = [];

        while (walker.nextNode())
        {
            var node = walker.currentNode;
            var t    = (node.nodeValue || '').trim().toLowerCase();

            if (t.indexOf('_product_gift_type:free_gift') !== -1 || t.indexOf('_milestone_id:') !== -1)
            {
                toRemove.push(node);
            }
        }

        toRemove.forEach(function(n)
        {
            var previous = n.previousSibling;
            var next     = n.nextSibling;

            n.parentNode.removeChild(n);

            if (previous && previous.nodeType === 1 && previous.tagName === 'BR') { previous.remove(); }
            if (next     && next.nodeType === 1 && next.tagName === 'BR')       { next.remove(); }
        });
    });
}

function initGuestPromoCopy()
{
    document.addEventListener('click', handleGuestPromoCopyClick);
}

function handleGuestPromoCopyClick(e)
{
    var btn = e.target.closest('.guest-pill__code-btn');
    if (!btn) { return; }

    var text = btn.getAttribute('data-copy-text') || '';
    if (!text) { return; }

    var icon = btn.querySelector('.guest-pill__icon');
    if (!icon) { return; }

    try
    {
        navigator.clipboard.writeText(text);
        icon.classList.add('guest-pill__icon--copied');
        setTimeout(function()
        {
            icon.classList.remove('guest-pill__icon--copied');
        }, 1200);
    }
    catch (err)
    {
        var tmp = document.createElement('input');
        tmp.value = text;
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        document.body.removeChild(tmp);

        icon.classList.add('guest-pill__icon--copied');
        setTimeout(function()
        {
            icon.classList.remove('guest-pill__icon--copied');
        }, 1200);
    }
}

function initAutoshipPromoCopy()
{
    document.addEventListener('click', handleAutoshipPromoCopyClick);
    document.addEventListener('click', handleGridPromoCopyClick);
}

function handleAutoshipPromoCopyClick(e)
{
    var btn = e.target.closest('.autoship-promo-pill .promo-bar__code');
    if (!btn) { return; }

    var code = btn.getAttribute('data-code');
    if (!code) { return; }

    navigator.clipboard.writeText(code);
    btn.classList.add('promo-bar__code--copied');
    btn.addEventListener('animationend', function onCopiedAnimationEnd()
    {
        btn.classList.remove('promo-bar__code--copied');
        btn.removeEventListener('animationend', onCopiedAnimationEnd);
    });
}

function handleGridPromoCopyClick(e)
{
    var btn = e.target.closest('.grid-promo-card__code');
    if (!btn) { return; }

    var code = btn.getAttribute('data-code');
    if (!code) { return; }

    navigator.clipboard.writeText(code);
    btn.classList.add('grid-promo-card__code--copied');
    btn.addEventListener('animationend', function onGridPromoCopiedEnd()
    {
        btn.classList.remove('grid-promo-card__code--copied');
        btn.removeEventListener('animationend', onGridPromoCopiedEnd);
    });
}

function initPromoSliderToggle()
{
    var bar    = document.querySelector('.promo-bar');
    if (!bar) { return; }

    var inner  = bar.querySelector('.promo-bar__inner');
    var slider = bar.querySelector('#promo-slider');
    if (!inner || !slider) { return; }

    function setPromoOpen(open)
    {
        var isOpen = (typeof open === 'boolean') ? open : !bar.classList.contains('is-open');

        if (isOpen)
        {
            bar.classList.add('is-open');
            slider.setAttribute('aria-hidden', 'false');
        }
        else
        {
            bar.classList.remove('is-open');
            slider.setAttribute('aria-hidden', 'true');
        }
    }

    var track = document.querySelector('.promo-track');
    if (track)
    {
        track.innerHTML += track.innerHTML;
    }


    function handlePromoInnerClick(e)
    {
        if (e.target && e.target.closest('a, button, summary, details, input, select, textarea')) { return; }
        if (window.matchMedia('(max-width: 768px)').matches) { setPromoOpen(); }
    }

    function handlePromoButtonClick(e)
    {
        e.stopPropagation();

        var btn = e.currentTarget;
        var expanded = btn.getAttribute('aria-expanded') === 'true';

        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        setPromoOpen(!expanded);
    }

    inner.addEventListener('click', handlePromoInnerClick);

    var buttons = bar.querySelectorAll('.promo-toggle');
    var i;
    for (i = 0; i < buttons.length; i++)
    {
        buttons[i].addEventListener('click', handlePromoButtonClick);
    }

    requestAnimationFrame(function()
    {
        bar.classList.add('promo-bar--ready');
    });
}

document.addEventListener('DOMContentLoaded', function()
{
    initGuestPromoCopy();
    initAutoshipPromoCopy();
    initPromoSliderToggle();
});

document.addEventListener('click', function(e)
{
    var infoBtn = e.target.closest('.what-is-autoship__info');
    var titleBtn = e.target.closest('.what-is-autoship__title');
    var popover = document.querySelector('.autoship-popover');
    var overlay = document.querySelector('.overlay');
    var closeBtn = e.target.closest('.autoship-popover__close');

    if (infoBtn || titleBtn)
    {
        popover.classList.add('active');
        overlay.classList.add('active');
        return;
    }

    if (closeBtn || e.target === overlay)
    {
        popover.classList.remove('active');
        overlay.classList.remove('active');
    }
});

document.addEventListener('click', function(e)
{
    var toggle = e.target.closest('.product-row__toggle');
    if (!toggle)
    {
        return;
    }

    var wrapper = toggle.previousElementSibling;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !expanded);
    wrapper.classList.toggle('is-expanded', !expanded);
});

function initPromoPopovers()
{
    var popovers = document.querySelectorAll('.promo-popover-wrap');
    popovers.forEach(function(popover)
    {
        var infoButton = popover.querySelector('.promo-info');
        var content = popover.querySelector('.promo-popover');
        if (!infoButton || !content)
        {
            return;
        }
        infoButton.addEventListener('click', function(e)
        {
            if (!window.matchMedia('(hover: none)').matches)
            {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            var isActive = content.classList.toggle('active');
            document.querySelectorAll('.promo-popover.active').forEach(function(other)
            {
                if (other !== content)
                {
                    other.classList.remove('active');
                }
            });
            if (isActive)
            {
                document.addEventListener('click', handleOutsideClick);
            }
        });
        function handleOutsideClick(e)
        {
            if (!popover.contains(e.target))
            {
                content.classList.remove('active');
                document.removeEventListener('click', handleOutsideClick);
            }
        }
    });
}

function InitQuestionSideDrawer()
{
    var triggers = document.querySelectorAll('.question-side-drawer');
    var drawer = document.querySelector('.question-side-drawer__panel');
    var close = document.querySelector('.question-side-drawer__close');
    var header = document.querySelector('.header-content');
    var nav = document.querySelector('.secondary-navigation-section');
    var mobnav = document.querySelector('.sticky-nav-mob');

    if ( !triggers.length || !drawer )
    {
        return;
    }

    function openDrawer(event)
    {
        event.preventDefault();

        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';

        if ( header )
        {
            header.style.zIndex = '1';
        }

        if ( nav )
        {
            nav.style.zIndex = '1';
        }

        if ( mobnav )
        {
            mobnav.style.display = 'none';
        }
    }

    function closeDrawer()
    {
        drawer.classList.remove('active');
        document.body.style.overflow = '';

        if ( header )
        {
            header.style.zIndex = '';
        }

        if ( nav )
        {
            nav.style.zIndex = '';
        }

        if ( mobnav )
        {
            mobnav.style.display = '';
        }
    }

    // open on trigger click
    triggers.forEach(function(trigger)
    {
        if ( !trigger.closest('.question-side-drawer__panel') )
        {
            trigger.addEventListener('click', openDrawer);
        }
    });

    // close button
    if ( close )
    {
        close.addEventListener('click', closeDrawer);
    }

    // close when clicking outside the drawer
    document.addEventListener('click', function(event)
    {
        var clickedInsideDrawer = drawer.contains(event.target);
        var clickedTrigger = Array.from(triggers).some(function(trigger)
        {
            return trigger.contains(event.target);
        });

        if ( drawer.classList.contains('active') && !clickedInsideDrawer && !clickedTrigger )
        {
            closeDrawer();
        }
    });

    // close on ESC key
    document.addEventListener('keydown', function(event)
    {
        if ( event.key === 'Escape' && drawer.classList.contains('active') )
        {
            closeDrawer();
        }
    });
}

document.addEventListener('DOMContentLoaded', InitQuestionSideDrawer);

function initPDPPurchaseTypeToggle( )
{
    function togglePurchaseType( radio )
    {
        var value = radio.value;
        var buttons = document.querySelectorAll( ".js-ptt-control" );
        buttons.forEach( button =>
        {
            button.style.display = "none";
        });

        var buttonToShow = document.querySelector( ".js-ptt-control-" + value );
        if ( buttonToShow )
        {
            buttonToShow.style.display = "";
        }
    }

    var block = document.querySelector( ".product-row-ptt" );
    if ( block )
    {
        block.classList.remove( "hidden" );
    }
    var radios = document.querySelectorAll( ".product-row-ptt .js-ptt-input" );
    radios.forEach( radio =>
    {
        // On initialisation, check which radio is checked and switch to that.
        if ( radio.checked )
        {
            togglePurchaseType( radio );
        }

        radio.addEventListener( "change", function( )
        {
            togglePurchaseType( radio )
        } );
    });

    var autoship = document.querySelector( ".js-ptt-control-autoship" );
    if ( autoship && radios.length > 0 )
    {
        autoship.style.display = "none";
    }
    else
    {
      autoship.classList.add( "visibility-hidden" );
    }

	var autoshipDetails      = document.querySelector( ".js-pdp-autoship-code-details" );
	var autoshipDetailsModal = document.querySelector( ".js-ptt-autoship-modal" );
	if ( autoshipDetails && autoshipDetailsModal )
	{
		autoshipDetails.addEventListener( "click", function( )
		{
			autoshipDetailsModal.classList.add( "info__code__modal--active" );
		});

		document.addEventListener( "click", function( e )
		{
			if ( !e.target.closest( ".js-ptt-autoship-modal" ) && !e.target.closest( ".js-pdp-autoship-code-details" ) )
			{
				autoshipDetailsModal.classList.remove( "info__code__modal--active" );
			}
		});
	}
}


function initCopyCodeToClipboard( )
{
	var copyButtons    = document.querySelectorAll( ".js-copy-code-clipboard" )
	var clipboardModal = document.querySelector( ".js-clipboard-modal" );
	if ( !clipboardModal )
	{
		return;
	}
	copyButtons.forEach( copyButton =>
	{
		var code = copyButton.dataset.code;
		if ( code )
		{
			copyButton.addEventListener( "click", function( )
			{
				var textEl = clipboardModal.querySelector( ".js-clipboard-modal-text" );
				if ( textEl )
				{
					var textPlaceholder = textEl.dataset.text;
					textPlaceholder = textPlaceholder.replaceAll( "%code%", code );
					navigator.clipboard.writeText( code );
					textEl.textContent = textPlaceholder;
					clipboardModal.classList.add( "clipboard-modal--active" );
					setTimeout( ( ) =>
					{
						clipboardModal.classList.remove( "clipboard-modal--active" );
					}, 5000)
				}
			});
		}
	});

	var closeModal = clipboardModal.querySelector( ".js-clipboard-modal-close" );
	closeModal.addEventListener( "click", function( )
	{
		clipboardModal.classList.remove( "clipboard-modal--active" );
	});
}

function initPDPAccordions( )
{
	var accordions = document.querySelectorAll( ".product-row-single-accordion" );

	accordions.forEach( accordion =>
	{
		var button  = accordion.querySelector( ".js-single-accordion-trigger" );
		var content = accordion.querySelector( ".js-single-accordion-content" );


		if ( button && content )
		{
			button.addEventListener( "click", function( )
			{
				if ( accordion.classList.contains( "product-row-single-accordion--active" ) )
				{
					accordion.classList.remove( "product-row-single-accordion--active" );
					content.style.maxHeight = "0";
				}

				else
				{
					accordion.classList.add( "product-row-single-accordion--active" );
					content.style.maxHeight = content.scrollHeight + "px";
				}
			});
		}
	});
}

function initPDPStickATC( )
{
    var stickyATC    = document.querySelector(".js-sticky-atc");
    var normalATC    = document.querySelector(".onetime-purchase-controls");
    var stickyNavMob = document.querySelector(".sticky-nav-mob");
    var autoshipATC  = document.querySelector(".js-ptt-control-autoship");

    if (!stickyATC || !normalATC)
    {
        return;
    }

    function hideUnselectedStickyButtonMobile()
    {
        var oneTimeQuantity  = stickyATC.querySelector(".product-quantity-col");
        var oneTimeButton    = stickyATC.querySelector(".product-buy-button-col");
        var autoshipButton   = stickyATC.querySelector(".product-buy-button-col-autoship");
        var autoshipQuantity = stickyATC.querySelector(".pdp-autoship-qty");
        var selectedRadio    = document.querySelector(".product-row-ptt .js-ptt-input:checked");
        var isAutoship       = selectedRadio && selectedRadio.value === "autoship";

        if (window.innerWidth > 768)
        {
            if (oneTimeQuantity) oneTimeQuantity.style.display   = "";
            if (oneTimeButton)   oneTimeButton.style.display     = "";
            if (autoshipButton)  autoshipButton.style.display    = "";
            if (autoshipQuantity) autoshipQuantity.style.display = "";
            return;
        }

        if (isAutoship)
        {
            if (oneTimeQuantity) oneTimeQuantity.style.display   = "none";
            if (oneTimeButton)   oneTimeButton.style.display     = "none";
            if (autoshipButton)  autoshipButton.style.display    = "";
            if (autoshipQuantity) autoshipQuantity.style.display = "";
        }
        else
        {
            if (oneTimeQuantity) oneTimeQuantity.style.display   = "";
            if (oneTimeButton)   oneTimeButton.style.display     = "";
            if (autoshipButton)  autoshipButton.style.display    = "none";
            if (autoshipQuantity) autoshipQuantity.style.display = "none";
        }
    }

    window.addEventListener("scroll", function( )
    {
        if (window.scrollY < 200)
        {
            stickyATC.classList.remove("sticky-atc-modal--active");
            if (stickyNavMob) stickyNavMob.style.display = "";
            return;
        }

        var selectedRadio = document.querySelector(".product-row-ptt .js-ptt-input:checked");
        var activeATC = normalATC;

        if (selectedRadio && selectedRadio.value === "autoship" && autoshipATC)
        {
            activeATC = autoshipATC;
        }

        var rect = activeATC.getBoundingClientRect();
        var visible = (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));

        if (!visible)
        {
            stickyATC.classList.add("sticky-atc-modal--active");
            if (stickyNavMob) stickyNavMob.style.display = "none";
        }
        else
        {
            stickyATC.classList.remove("sticky-atc-modal--active");
            if (stickyNavMob) stickyNavMob.style.display = "";
        }

        hideUnselectedStickyButtonMobile();
    });


    document.querySelectorAll(".js-ptt-input").forEach(function(radio)
    {
        radio.addEventListener("change", function()
        {
            hideUnselectedStickyButtonMobile();
        });
    });

    hideUnselectedStickyButtonMobile();

    var autoshipPriceEl = document.querySelector(".top__prices__autoship-price");
    var normalPriceEl   = document.querySelector(".product-main-price");
    var comparePriceEl  = document.querySelector(".product-compare-price");

    var stickyAutoBtns = stickyATC.querySelectorAll(".product-buy-button-col-autoship .autoship-add-to-cart, .sticky-autoship-trigger");

    stickyAutoBtns.forEach(function(btn)
    {
        if (!autoshipPriceEl || !normalPriceEl) return;

        var autoPriceText   = autoshipPriceEl.textContent.trim();
        var normalPriceText = normalPriceEl.textContent.trim();

        var priceHTML =
            '<span class="sticky-autoship-prices" style="display:flex; align-items:center; gap:8px; margin-left:auto;">' +
                '<span class="sticky-normal-price" style="text-decoration:line-through; opacity:0.7; font-size:13px;">' + normalPriceText + '</span>' +
                '<span class="sticky-auto-price" style="font-weight:700; font-size:15px;">' + autoPriceText + '</span>' +
            '</span>';

        if (!btn.querySelector(".sticky-autoship-prices"))
        {
            btn.insertAdjacentHTML("beforeend", priceHTML);
        }
    });

    var stickyOneBtns = stickyATC.querySelectorAll(".product-buy-button-col .product-form__submit");

    stickyOneBtns.forEach(function(btn)
    {
        if (!normalPriceEl) return;

        var normalPriceText  = normalPriceEl.textContent.trim();
        var comparePriceText = comparePriceEl ? comparePriceEl.textContent.trim() : null;

        var priceHTML =
            '<span class="sticky-onetime-prices" style="display:flex; align-items:center; gap:8px; margin-left:auto;">' +
                (comparePriceText ? '<span class="sticky-compare" style="text-decoration:line-through; opacity:0.7; font-size:13px;">' + comparePriceText + '</span>' : '') +
                '<span class="sticky-onetime-price" style="font-weight:700; font-size:15px;">' + normalPriceText + '</span>' +
            '</span>';

        if (!btn.querySelector(".sticky-onetime-prices"))
        {
            btn.insertAdjacentHTML("beforeend", priceHTML);
        }
    });
}




document.addEventListener("click", function(e)
{
    var trigger = e.target.closest(".sticky-autoship-trigger");
    if (!trigger)
    {
        return;
    }

    trigger.querySelector( "svg" ).classList.add( "autoship-icon--rotating" );

    var realButton = document.querySelector(".autoship-add-to-cart");

    if (realButton)
    {
        realButton.click();
    }
});

document.addEventListener('click', function(e)
{
    var pop = document.querySelector('.js-onetime-popover');
    if ( pop )
    {
        var overlay = document.querySelector('.overlay');

        var isOpen = pop.classList.contains('active');

        if (e.target.closest('.js-pdp-onetime-code-details'))
        {
            pop.classList.add('active');
            overlay.classList.add('active');
            return;
        }

        if (e.target.closest('.js-onetime-close'))
        {
            pop.classList.remove('active');
            overlay.classList.remove('active');
            return;
        }

        if (e.target.closest('.overlay'))
        {
            pop.classList.remove('active');
            overlay.classList.remove('active');
            return;
        }

        if (isOpen && !e.target.closest('.js-onetime-popover'))
        {
            pop.classList.remove('active');
            overlay.classList.remove('active');
            return;
        }
    }
});


function setupPttPriceSwitcher()
{
    var pttInputs = document.querySelectorAll('.js-ptt-input');

    if (!pttInputs || pttInputs.length === 0)
    {
        return;
    }

    var mainPriceEl = document.querySelector('.product-main-price');
    var discountEl = document.querySelector('.product-discount-percentage');
    var compareEl = document.querySelector('.product-compare-price');
    
    // Store the initial price immediately, before any modifications
    // This ensures we capture the correct regular price even for autoship members
    var initialMainPrice = mainPriceEl ? mainPriceEl.textContent.trim() : null;
    
    // Get the normal price from multiple sources, prioritizing the most reliable
    // 1. Try .top__prices__curr-price (regular price shown in purchase type toggle)
    // 2. Try .top__price (one-time purchase price in the toggle)  
    // 3. Use the initial main price we captured (before any JS modifications)
    var currPriceEl = document.querySelector('.top__prices__curr-price');
    var onetimePriceEl = document.querySelector('.ptt__onetime .top__price');
    var normalPrice = null;
    
    if (currPriceEl && currPriceEl.textContent.trim())
    {
        normalPrice = currPriceEl.textContent.trim();
    }
    else if (onetimePriceEl && onetimePriceEl.textContent.trim())
    {
        normalPrice = onetimePriceEl.textContent.trim();
    }
    else if (initialMainPrice)
    {
        // Use the initial price captured before any modifications
        // This handles cases where .top__prices__curr-price doesn't exist (autoship members)
        normalPrice = initialMainPrice;
    }
    
    var normalDiscount = discountEl ? discountEl.textContent.trim() : null;
    
    // Check initial state - if autoship is already selected, set price immediately
    var initialCheckedValue = null;
    for (var j = 0; j < pttInputs.length; j++)
    {
        if (pttInputs[j].checked)
        {
            initialCheckedValue = pttInputs[j].value;
            break;
        }
    }
    
    // Function to check if user has active autoship (check dynamically)
    function hasActiveAutoship()
    {
        return document.body.classList.contains('has-autoship');
    }
    
    // Function to set initial price based on autoship status
    function setInitialPrice()
    {
        if (!mainPriceEl || !normalPrice) return;
        
        // Check current state, not just initial state (in case autoship was programmatically selected)
        var currentCheckedValue = null;
        for (var k = 0; k < pttInputs.length; k++)
        {
            if (pttInputs[k].checked)
            {
                currentCheckedValue = pttInputs[k].value;
                break;
            }
        }
        
        if (hasActiveAutoship())
        {
            // Active autoship users: always show regular product price
            mainPriceEl.textContent = normalPrice;
        }
        else if (currentCheckedValue === 'autoship')
        {
            // Non-autoship users with autoship selected: show autoship price
            var initialRow = pttInputs[0].closest('.product-row');
            if (initialRow)
            {
                var initialAutoshipPriceEl = initialRow.querySelector('.top__prices__autoship-price');
                if (initialAutoshipPriceEl && initialAutoshipPriceEl.textContent.trim())
                {
                    var autoshipPriceText = initialAutoshipPriceEl.textContent.trim();
                    // Only update if we have a valid autoship price
                    if (autoshipPriceText && autoshipPriceText !== mainPriceEl.textContent.trim())
                    {
                        mainPriceEl.textContent = autoshipPriceText;
                    }
                }
                // Don't fall back to normalPrice if autoship is selected - wait for element to be ready
            }
        }
        else
        {
            // One-time selected or no selection
            mainPriceEl.textContent = normalPrice;
        }
    }
    
    // Set initial price - check multiple times in case has-autoship class is added asynchronously
    // or autoship button is clicked programmatically
    setInitialPrice();
    setTimeout(setInitialPrice, 100);
    setTimeout(setInitialPrice, 500);
    setTimeout(setInitialPrice, 1000);
    setTimeout(setInitialPrice, 2000); // Extra delay for programmatic autoship selection
    
    // Watch for when autoship radio button becomes checked (for programmatic selection)
    if (pttInputs.length > 0)
    {
        var autoshipInput = null;
        for (var m = 0; m < pttInputs.length; m++)
        {
            if (pttInputs[m].value === 'autoship')
            {
                autoshipInput = pttInputs[m];
                break;
            }
        }
        
        if (autoshipInput)
        {
            // Watch for when autoship becomes checked
            var checkObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'checked')
                    {
                        if (autoshipInput.checked && !hasActiveAutoship())
                        {
                            // Autoship was just checked for non-autoship user, update price
                            setTimeout(setInitialPrice, 50);
                        }
                    }
                });
            });
            
            checkObserver.observe(autoshipInput, { attributes: true, attributeFilter: ['checked'] });
        }
    }
    
    // Watch for has-autoship class being added
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                // Only update if class was added (not removed)
                if (hasActiveAutoship() && mainPriceEl && normalPrice)
                {
                    // If autoship class was just added, ensure price is set to regular price
                    mainPriceEl.textContent = normalPrice;
                }
                else if (!hasActiveAutoship())
                {
                    // If class was removed, re-check the current selection
                    setInitialPrice();
                }
            }
        });
    });
    
    if (document.body)
    {
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    for (var i = 0; i < pttInputs.length; i++)
    {
        var input = pttInputs[i];

        input.addEventListener('change', function ()
        {
            var row = this.closest('.product-row');

            if (!row)
            {
                return;
            }

            if (this.value === 'autoship')
            {
                var autoshipPriceEl = row.querySelector('.top__prices__autoship-price');

                // Only update main price for non-autoship users
                // Active autoship users: main price always stays as regular product price
                // Check dynamically each time in case class is added/removed
                if (!hasActiveAutoship() && autoshipPriceEl && mainPriceEl)
                {
                    var autoshipPrice = autoshipPriceEl.textContent.trim();
                    if (autoshipPrice)
                    {
                        mainPriceEl.textContent = autoshipPrice;
                    }
                }
                else if (hasActiveAutoship() && mainPriceEl && normalPrice)
                {
                    // Ensure autoship users always see regular price
                    mainPriceEl.textContent = normalPrice;
                }

                // Update discount percentage if needed
                if (discountEl && compareEl && autoshipPriceEl)
                {
                    var compareAt = parseFloat(compareEl.textContent.replace(/[^0-9.]/g, ''));
                    var autoPrice = parseFloat(autoshipPriceEl.textContent.replace(/[^0-9.]/g, ''));

                    if (!isNaN(compareAt) && compareAt > 0)
                    {
                        var percent = Math.round(((compareAt - autoPrice) / compareAt) * 100);
                        discountEl.textContent = '- ' + percent + '%';
                    }
                }
            }
            else
            {
                if (mainPriceEl)
                {
                    // When switching to one-time, use the normal price
                    mainPriceEl.textContent = normalPrice;
                }

                if (discountEl)
                {
                    discountEl.textContent = normalDiscount;
                }
            }
        });
    }
}

function DisableMembershipCTA( )
{
    var cta           = null;
    var wrapper       = null;
    var isMembership  = false;
    var hasQuizParam  = false;

    cta     = document.querySelector( ".membership-cta-redesigned" );
    wrapper = document.querySelector( ".membership-wrapper-redesigned[data-membership-variant-id]" );

    isMembership   = ( window.location.pathname == "/pages/membership-steps" );
    hasQuizParam   = ( window.location.search.indexOf( "quizsteps" ) >= 0 );

    var skipAttach = ( wrapper && cta && cta.classList.contains( "js-membership-redesign-cta" ) );

    if ( !skipAttach && isMembership && cta )
    {
        if ( hasQuizParam )
        {
            cta.addEventListener( "click", DisableMembershipCTA_OnClick );
        }
        else
        {
            cta.addEventListener( "click", DisableMembershipCTA_RedirectToCheckout );
        }
    }
}

function DisableMembershipCTA_OnClick( event )
{
    event.preventDefault( );
    window.location.href = "/pages/welleasy-quiz?slide=16";
}

function DisableMembershipCTA_RedirectToCheckout( event )
{
    event.preventDefault( );
    window.location.href = "/checkout";
}


document.addEventListener("DOMContentLoaded", function()
{
    SetupOrdersListScrollFix();
    SetupManageOrderLink();
    flipWECWidgetLink();
    populateWellEasyCash();
    initAutoshipNextOrderWidgets();
    initSecondaryNav();
    handleCustomLoyaltyContent();
    initScrollers( );
    initHeroTextSliders( );
    initWelleasyCashNoFlicker();
    initPromoPopovers();
    initPDPAccordions( );
    initCopyCodeToClipboard( );
    initPDPStickATC( );
    setupPttPriceSwitcher();
    DisableMembershipCTA();
    
    // mw 20251020: removed. wtf ??
    //setTimeout(hideGiftPropertiesCart, 1500);
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////
// EC handling
//////////////////////////////////////////////////////////////////////////////////////////////////////////
function MakeVariantList( product, key )
{
    var result = "";

    for ( var i = 0; i < product.variants.length; i++ )
    {
        if ( i > 0 )
        {
            result += ";";
        }
        result += product.variants[ i ][ key ];
    }
    
    return ( result );
}

function SetupECCardLinks( card, product )
{
    var imageLink         = document.createElement( "a" );
    var oldImageContainer = card.querySelector( ".ec-product-image-container" );
    imageLink.innerHTML   = oldImageContainer.innerHTML;
    imageLink.classList.add( "ec-product-image-container" );
    imageLink.setAttribute( "id", "product-card-image-container" );
    imageLink.setAttribute( "href", product.url );
    oldImageContainer.insertAdjacentElement( "beforebegin", imageLink );
    oldImageContainer.remove( );

    var bodyLink = document.createElement( "a" );
    bodyLink.classList.add( "product-card__info-container" );
    bodyLink.setAttribute( "href", product.url );
    var title = card.querySelector( ".ec-product-title" );
    var titleCopy = title.cloneNode( true );
    var vendor = card.querySelector( ".ec-product-vendor" );
    var vendorCopy = vendor.cloneNode( true );
    bodyLink.appendChild( vendorCopy );
    bodyLink.appendChild( titleCopy );
    title.insertAdjacentElement( "beforebegin", bodyLink );
    vendor.remove( );
    title.remove( );
}

function SetupECCardBrandReview( card, product )
{
    var skus           = MakeVariantList( product, "sku" );
    var ids            = MakeVariantList( product, "id" );
    var skuPlaceholder = product.handle + ";" + skus + ";" + ids;
    var brandRow       =
    `
        <div class="product-card__brand-review-container">
            <p class="product-card__brand">${product.vendor}</p>
            <div class="ruk_rating_snippet" data-sku="${skuPlaceholder}"></div>
        </div>
    `;
    var standardVendor = card.querySelector( ".ec-product-vendor" );

    if ( standardVendor )
    {
        standardVendor.insertAdjacentHTML( "beforebegin", brandRow );
        standardVendor.remove( );

        reinitialiseRatingSnippet( );
        WE_ReviewsIo_StripReviewTextAndBracketCount( );
        setTimeout( WE_ReviewsIo_StripReviewTextAndBracketCount, 500 );
    }

    return;
}


function SetupECCardDiscount( card, firstVariant )
{
    var percentageDifference = 0;
    if ( firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price )
    {
        var difference = firstVariant.compare_at_price - firstVariant.price;
        percentageDifference = Math.round( ( difference * 100 ) / firstVariant.compare_at_price );
    }
    var discountHTML = "<span class=\"product-card__discount\"" + ( percentageDifference <= 0 ? " style=\"display: none;\"" : "" ) + ">" + percentageDifference + "% off</span>";
    card.insertAdjacentHTML( "afterbegin", discountHTML );
}

function SetupECCardAttributes( card, product, variantId, firstVariant )
{
    card.classList.add( "product-grid__product-card" );
    card.classList.add( "product-grid__product-card--not-collection" );
    card.classList.add( "product-grid__product-card--no-mobile" );
    card.setAttribute( "data-product-id", product.id );
    card.setAttribute( "data-variant-id", variantId );
    
    var productUrl     = product.url || "";
    var priceFormatted = ( firstVariant.price / 100 ).toFixed( 2 ) + " GBP";
    var comparePrice   = priceFormatted;
    if ( firstVariant.compare_at_price )
    {
        comparePrice = ( firstVariant.compare_at_price / 100 ).toFixed( 2 ) + " GBP";
    }
    
    var productDataJson = "{\"url\":\"" + productUrl + "\",\"attributes\":{\"to_cart_variant_id\":[\"" + variantId + "\"],\"price\":\"" + priceFormatted + "\",\"price_old\":\"" + comparePrice + "\",\"to_cart_product_id\":[\"" + product.id + "\"],\"title\":\"" + product.title.replace( /"/g, "\\\"" ) + "\",\"brand\":\"" + product.vendor.replace( /"/g, "\\\"" ) + "\",\"image_link\":\"" + ( product.featured_image || "" ) + "\"}}";
    card.setAttribute( "data-product-data", productDataJson );
    card._productData = JSON.parse( productDataJson );
}

function SetupECCardPrices( card, product, firstVariant, hasAutoship )
{
    var oldPrice = card.querySelector( ".ec-product-price" );
    if ( oldPrice )
    {

        var priceFormatted  = ( firstVariant.price / 100 ).toFixed( 2 );
        var comparePrice    = priceFormatted;

        if ( firstVariant.compare_at_price )
        {
            comparePrice = ( firstVariant.compare_at_price / 100 ).toFixed( 2 );
        }
        var priceElement =
        `
        <div class="product-card__price-container">
          <div class="product-card__main-price"><span class="product-card__price__full"></span><span class="product-card__price__discounted"></span>
          </div>
          <div class="product-card__price--autoship">
			<svg xmlns="http://www.w3.org/2000/svg" width="22" height="15" viewBox="0 0 22 15" fill="none">
				<path d="M20.938 4.52618C20.9263 4.52549 20.9507 4.52116 21.0044 4.59161C21.0533 4.65574 21.1018 4.75088 21.1479 4.8631C21.2395 5.08568 21.3024 5.3344 21.3286 5.44025C21.4313 5.85097 21.4383 6.19319 21.4312 6.42657V6.42853C21.4093 7.5161 21.1147 8.42577 20.8765 9.01154C20.7451 9.33418 20.5918 9.6493 20.4136 9.95782L20.2271 10.2635C18.1692 13.4636 14.2197 14.837 10.5767 13.6609L10.2251 13.5389C9.94338 13.4355 9.66997 13.3178 9.40869 13.1834L9.40674 13.1824C9.01046 12.9829 8.71 12.8278 8.47803 12.6844C8.24712 12.5416 8.09569 12.4177 7.99072 12.285H7.98975C7.96867 12.2573 7.88628 12.1466 7.74561 12.1209V12.1199L7.73486 12.119H7.64893C7.56814 12.1305 7.50249 12.1722 7.45361 12.2166C7.39314 12.2717 7.34065 12.3473 7.29346 12.4197C7.19133 12.5765 7.08437 12.7688 6.90479 13.0135C6.57139 13.4677 6.3297 13.6369 6.17432 13.7234L6.16943 13.7264C6.15368 13.7357 6.13643 13.7408 6.12158 13.7488L6.0835 13.6961C5.8908 13.4143 5.35022 12.6088 5.06396 11.5457C4.82966 10.6667 4.84975 9.91956 4.89111 8.4754V8.46954C4.89111 8.4532 4.89164 8.43727 4.89209 8.42169C4.91137 8.41875 4.93228 8.4154 4.95459 8.41193C5.4896 8.32805 6.5544 8.16478 7.66553 8.31036C8.22829 8.38495 9.19241 8.44012 10.3647 8.8504V8.85138C10.411 8.86811 10.4539 8.88462 10.4937 8.89923C10.3538 9.2375 10.1357 9.45106 9.99951 9.5838C9.55987 9.9978 9.32657 10.2062 9.20264 10.3192C9.16097 10.3571 9.12711 10.392 9.1001 10.4197H8.95947L9.0083 10.66C9.02812 10.757 9.09679 10.821 9.14404 10.8572C9.19716 10.8979 9.26304 10.9333 9.3335 10.9637C9.47566 11.025 9.66801 11.0808 9.89502 11.1277C10.3512 11.222 10.9756 11.2854 11.688 11.2713C13.1113 11.243 14.9132 10.9051 16.437 9.86115C16.8351 9.58877 17.6499 8.96863 18.4644 8.15997C19.276 7.35413 20.1045 6.34447 20.5073 5.29181L20.5083 5.29083C20.5447 5.19375 20.623 4.98044 20.7261 4.79376C20.778 4.69969 20.8306 4.6226 20.8794 4.57306C20.9109 4.54117 20.9299 4.52952 20.938 4.52618Z" fill="#F7A855" stroke="black" stroke-width="0.4"></path>
				<path d="M1.40625 4.65311C3.53427 1.34973 7.67062 -0.00616685 11.4121 1.37479C11.6937 1.47817 11.9673 1.59494 12.2285 1.72928L12.2305 1.73026C12.6268 1.92983 12.9272 2.08488 13.1592 2.2283C13.39 2.37102 13.5415 2.49503 13.6465 2.62772C13.664 2.65063 13.729 2.73966 13.8398 2.77908L13.8916 2.79276L13.9023 2.79471C14.0236 2.80997 14.1184 2.7554 14.1836 2.69608C14.244 2.64108 14.2966 2.5663 14.3438 2.49393C14.4459 2.33711 14.5528 2.1449 14.7324 1.90018C15.0659 1.44584 15.3075 1.27678 15.4629 1.19022L15.4678 1.18729C15.4835 1.17793 15.4998 1.17091 15.5146 1.16287L15.5537 1.21756C15.7224 1.46428 16.1573 2.11081 16.4551 2.98026L16.5732 3.36697C16.8077 4.24617 16.7875 4.9938 16.7461 6.43826V6.44315C16.7461 6.45935 16.7446 6.47555 16.7441 6.491L16.6826 6.50174C16.1477 6.5856 15.0834 6.7487 13.9727 6.6033C13.4096 6.52863 12.4432 6.47244 11.2695 6.06131C11.2236 6.04468 11.1811 6.02798 11.1416 6.01346C11.2813 5.67526 11.5005 5.46168 11.6367 5.32889L11.6377 5.32986C12.0781 4.91518 12.3117 4.70644 12.4355 4.59354C12.493 4.54118 12.5383 4.49911 12.5664 4.46561C12.5812 4.44795 12.6052 4.41655 12.6191 4.37381C12.6358 4.32248 12.6301 4.27845 12.624 4.25076H12.6221C12.6006 4.15741 12.5354 4.09476 12.4893 4.05936C12.4362 4.01876 12.3701 3.98424 12.2998 3.95389C12.1577 3.89259 11.9662 3.8358 11.7393 3.78885C11.283 3.69449 10.658 3.63113 9.94531 3.64529C8.52197 3.67361 6.72013 4.01149 5.19629 5.05545C4.79819 5.32782 3.98343 5.94797 3.16895 6.75662C2.3573 7.56246 1.52878 8.57212 1.12598 9.62479V9.62576C1.08959 9.72282 1.01043 9.937 0.907227 10.1238C0.855339 10.2177 0.802618 10.2941 0.753906 10.3435C0.720376 10.3775 0.700455 10.3868 0.693359 10.3894C0.684344 10.3844 0.663079 10.3685 0.629883 10.325C0.581067 10.2609 0.531496 10.1665 0.485352 10.0545C0.439507 9.94308 0.4005 9.82482 0.370117 9.72147L0.304688 9.47635C0.201999 9.06563 0.195001 8.72341 0.202148 8.49002V8.48807C0.223984 7.40077 0.518683 6.49178 0.756836 5.90604C0.888124 5.58345 1.04157 5.26821 1.21973 4.95975L1.40625 4.65311Z" fill="#F7A855" stroke="black" stroke-width="0.4"></path>
			</svg>
            <strong>Autoship</strong> <span class="product-card__price-autoship-price">£2.90</span>
          </div>
		</div>
        `;

        var parser = new DOMParser( );
        var priceElement = parser.parseFromString( priceElement, "text/html" );
        priceElement = priceElement.querySelector( ".product-card__price-container" );
        if ( priceFormatted != comparePrice )
        {
            var fullPriceEl     = priceElement.querySelector( ".product-card__price__full" );
            var isQuizResults   = card.closest( ".we-onboarding-quiz-results-products" );
            if ( isQuizResults )
            {
                fullPriceEl.textContent = "£" + comparePrice;
            }
            else
            {
                fullPriceEl.textContent = "(RRP £" + comparePrice + ")";
            }
        }
        priceElement.querySelector( ".product-card__price__discounted" ).textContent = `£${ priceFormatted }`;

        if ( hasAutoship )
        {
            var autoshipPrice = ( firstVariant.selling_plan_allocations[ 0 ].price / 100 ).toFixed( 2 );
            priceElement.querySelector( ".product-card__price-autoship-price" ).textContent = `£${ autoshipPrice }`
        }
        else
        {
            priceElement.querySelector( ".product-card__price--autoship" ).remove( );
        }

        card.querySelector( ".product-card__info-container" ).appendChild( priceElement );
        oldPrice.remove( );
    }
}

function SetupECCardAutoshipPrice( card, priceContainer, hasAutoship )
{
    if ( priceContainer && hasAutoship )
    {
        var autoshipPriceHTML = "<div class=\"product-card__price--autoship\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"15\" viewBox=\"0 0 22 15\" fill=\"none\"><path d=\"M20.938 4.52618C20.9263 4.52549 20.9507 4.52116 21.0044 4.59161C21.0533 4.65574 21.1018 4.75088 21.1479 4.8631C21.2395 5.08568 21.3024 5.3344 21.3286 5.44025C21.4313 5.85097 21.4383 6.19319 21.4312 6.42657V6.42853C21.4093 7.5161 21.1147 8.42577 20.8765 9.01154C20.7451 9.33418 20.5918 9.6493 20.4136 9.95782L20.2271 10.2635C18.1692 13.4636 14.2197 14.837 10.5767 13.6609L10.2251 13.5389C9.94338 13.4355 9.66997 13.3178 9.40869 13.1834L9.40674 13.1824C9.01046 12.9829 8.71 12.8278 8.47803 12.6844C8.24712 12.5416 8.09569 12.4177 7.99072 12.285H7.98975C7.96867 12.2573 7.88628 12.1466 7.74561 12.1209V12.1199L7.73486 12.119H7.64893C7.56814 12.1305 7.50249 12.1722 7.45361 12.2166C7.39314 12.2717 7.34065 12.3473 7.29346 12.4197C7.19133 12.5765 7.08437 12.7688 6.90479 13.0135C6.57139 13.4677 6.3297 13.6369 6.17432 13.7234L6.16943 13.7264C6.15368 13.7357 6.13643 13.7408 6.12158 13.7488L6.0835 13.6961C5.8908 13.4143 5.35022 12.6088 5.06396 11.5457C4.82966 10.6667 4.84975 9.91956 4.89111 8.4754V8.46954C4.89111 8.4532 4.89164 8.43727 4.89209 8.42169C4.91137 8.41875 4.93228 8.4154 4.95459 8.41193C5.4896 8.32805 6.5544 8.16478 7.66553 8.31036C8.22829 8.38495 9.19241 8.44012 10.3647 8.8504V8.85138C10.411 8.86811 10.4539 8.88462 10.4937 8.89923C10.3538 9.2375 10.1357 9.45106 9.99951 9.5838C9.55987 9.9978 9.32657 10.2062 9.20264 10.3192C9.16097 10.3571 9.12711 10.392 9.1001 10.4197H8.95947L9.0083 10.66C9.02812 10.757 9.09679 10.821 9.14404 10.8572C9.19716 10.8979 9.26304 10.9333 9.3335 10.9637C9.47566 11.025 9.66801 11.0808 9.89502 11.1277C10.3512 11.222 10.9756 11.2854 11.688 11.2713C13.1113 11.243 14.9132 10.9051 16.437 9.86115C16.8351 9.58877 17.6499 8.96863 18.4644 8.15997C19.276 7.35413 20.1045 6.34447 20.5073 5.29181L20.5083 5.29083C20.5447 5.19375 20.623 4.98044 20.7261 4.79376C20.778 4.69969 20.8306 4.6226 20.8794 4.57306C20.9109 4.54117 20.9299 4.52952 20.938 4.52618Z\" fill=\"#F7A855\" stroke=\"black\" stroke-width=\"0.4\"/><path d=\"M1.40625 4.65311C3.53427 1.34973 7.67062 -0.00616685 11.4121 1.37479C11.6937 1.47817 11.9673 1.59494 12.2285 1.72928L12.2305 1.73026C12.6268 1.92983 12.9272 2.08488 13.1592 2.2283C13.39 2.37102 13.5415 2.49503 13.6465 2.62772C13.664 2.65063 13.729 2.73966 13.8398 2.77908L13.8916 2.79276L13.9023 2.79471C14.0236 2.80997 14.1184 2.7554 14.1836 2.69608C14.244 2.64108 14.2966 2.5663 14.3438 2.49393C14.4459 2.33711 14.5528 2.1449 14.7324 1.90018C15.0659 1.44584 15.3075 1.27678 15.4629 1.19022L15.4678 1.18729C15.4835 1.17793 15.4998 1.17091 15.5146 1.16287L15.5537 1.21756C15.7224 1.46428 16.1573 2.11081 16.4551 2.98026L16.5732 3.36697C16.8077 4.24617 16.7875 4.9938 16.7461 6.43826V6.44315C16.7461 6.45935 16.7446 6.47555 16.7441 6.491L16.6826 6.50174C16.1477 6.5856 15.0834 6.7487 13.9727 6.6033C13.4096 6.52863 12.4432 6.47244 11.2695 6.06131C11.2236 6.04468 11.1811 6.02798 11.1416 6.01346C11.2813 5.67526 11.5005 5.46168 11.6367 5.32889L11.6377 5.32986C12.0781 4.91518 12.3117 4.70644 12.4355 4.59354C12.493 4.54118 12.5383 4.49911 12.5664 4.46561C12.5812 4.44795 12.6052 4.41655 12.6191 4.37381C12.6358 4.32248 12.6301 4.27845 12.624 4.25076H12.6221C12.6006 4.15741 12.5354 4.09476 12.4893 4.05936C12.4362 4.01876 12.3701 3.98424 12.2998 3.95389C12.1577 3.89259 11.9662 3.8358 11.7393 3.78885C11.283 3.69449 10.658 3.63113 9.94531 3.64529C8.52197 3.67361 6.72013 4.01149 5.19629 5.05545C4.79819 5.32782 3.98343 5.94797 3.16895 6.75662C2.3573 7.56246 1.52878 8.57212 1.12598 9.62479V9.62576C1.08959 9.72282 1.01043 9.937 0.907227 10.1238C0.855339 10.2177 0.802618 10.2941 0.753906 10.3435C0.720376 10.3775 0.700455 10.3868 0.693359 10.3894C0.684344 10.3844 0.663079 10.3685 0.629883 10.325C0.581067 10.2609 0.531496 10.1665 0.485352 10.0545C0.439507 9.94308 0.4005 9.82482 0.370117 9.72147L0.304688 9.47635C0.201999 9.06563 0.195001 8.72341 0.202148 8.49002V8.48807C0.223984 7.40077 0.518683 6.49178 0.756836 5.90604C0.888124 5.58345 1.04157 5.26821 1.21973 4.95975L1.40625 4.65311Z\" fill=\"#F7A855\" stroke=\"black\" stroke-width=\"0.4\"/></svg><strong>Autoship</strong> <span class=\"product-card__price-autoship-price\"></span></div>";
        var mainPrice = priceContainer.querySelector( ".product-card__main-price" );
        if ( mainPrice )
        {
            mainPrice.insertAdjacentHTML( "afterend", autoshipPriceHTML );
        }
        else
        {
            priceContainer.insertAdjacentHTML( "beforeend", autoshipPriceHTML );
        }
    }
}

function SetupECCardOnetimeButton( card, product, firstVariant )
{
    var onetime = card.querySelector( ".ec-add-to-cart" );
    if ( onetime )
    {
        onetime.classList.add( "product-card__buy-button" );
        onetime.dataset.variantId = firstVariant.id;

        var parser = new DOMParser( );
        var quantityInput =
        `
        <quantity-input class="quantity quantity-wrapper hidden" data-item-in-cart="true"data-variant-id="${ firstVariant.id }">
				<button class="quantity__button no-js-hidden" name="minus" type="button">
					<span class="visually-hidden">Quantity</span>
					<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 8.1001H5.25C4.83525 8.1001 4.5 8.5033 4.5 9.0001C4.5 9.4969 4.83525 9.9001 5.25 9.9001H12.75C13.1648 9.9001 13.5 9.4969 13.5 9.0001C13.5 8.5033 13.1648 8.1001 12.75 8.1001Z" fill="black"/>
					</svg>
				</button>
				<div class="quantity-button-input-wrapper">
                    <input class="quantity__input" type="number" name="quantity"  data-cart-quantity="0" data-min="1" min="1" step="1" value="0">
					<span class="quantity-input__text">in Cart</span>
                </div>
				<button class="quantity__button no-js-hidden" name="plus" type="button">
					<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
						<path d="M5 0.5C4.58579 0.5 4.25 0.835786 4.25 1.25V4.25H1.25C0.835786 4.25 0.5 4.58579 0.5 5C0.5 5.41421 0.835786 5.75 1.25 5.75H4.25V8.75C4.25 9.16421 4.58579 9.5 5 9.5C5.41421 9.5 5.75 9.16421 5.75 8.75V5.75H8.75C9.16421 5.75 9.5 5.41421 9.5 5C9.5 4.58579 9.16421 4.25 8.75 4.25H5.75V1.25C5.75 0.835786 5.41421 0.5 5 0.5Z" fill="black"/>
					</svg>
				</button>
			</quantity-input>
        `;

        quantityInput = parser.parseFromString( quantityInput, "text/html" ).querySelector( ".quantity" );
        onetime.insertAdjacentElement( "beforebegin", quantityInput );
    }
}

function SetupECCardAutoshipButton( card, product, variantId, firstVariant, hasAutoship, priceFormatted, comparePrice )
{
    var addToCartButton = card.querySelector( ".ec-add-to-cart" );
    if ( addToCartButton )
    {
        var membershipVariantId     = "";
        var membershipSellingPlanId = "";
        if ( hasAutoship )
        {
            membershipSellingPlanId = firstVariant.selling_plan_allocations[0].selling_plan_id || "";
            if ( firstVariant.selling_plan_allocations[0].price_adjustments && firstVariant.selling_plan_allocations[0].price_adjustments.length > 0 )
            {
                membershipVariantId = firstVariant.selling_plan_allocations[0].price_adjustments[0].value || "";
            }
        }

        var autoshipBtnClass = "";
        if ( !hasAutoship )
        {
            autoshipBtnClass = "visibility-hidden";
        }
    
        var autoshipSvg = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"14\" viewBox=\"0 0 22 14\" fill=\"none\" style=\"vertical-align:middle;\"><path d=\"M20.938 3.88773C20.9263 3.88703 20.9507 3.8827 21.0044 3.95316C21.0533 4.01728 21.1018 4.11242 21.1479 4.22464C21.2395 4.44722 21.3024 4.69594 21.3286 4.80179C21.4313 5.21251 21.4383 5.55473 21.4312 5.78812V5.79007C21.4093 6.87764 21.1147 7.78731 20.8765 8.37308C20.7451 8.69572 20.5918 9.01084 20.4136 9.31937L20.2271 9.62503C18.1692 12.8252 14.2197 14.1985 10.5767 13.0225L10.2251 12.9004C9.94338 12.797 9.66997 12.6793 9.40869 12.545L9.40674 12.544C9.01046 12.3444 8.71 12.1893 8.47803 12.0459C8.24712 11.9032 8.09569 11.7793 7.99072 11.6465H7.98975C7.96867 11.6188 7.88628 11.5082 7.74561 11.4825V11.4815L7.73486 11.4805H7.64893C7.56814 11.492 7.50249 11.5337 7.45361 11.5782C7.39314 11.6332 7.34065 11.7088 7.29346 11.7813C7.19133 11.9381 7.08437 12.1303 6.90479 12.375C6.57139 12.8292 6.3297 12.9984 6.17432 13.085L6.16943 13.0879C6.15368 13.0973 6.13643 13.1024 6.12158 13.1104L6.0835 13.0576C5.8908 12.7759 5.35022 11.9703 5.06396 10.9073C4.82966 10.0283 4.84975 9.2811 4.89111 7.83694V7.83109C4.89111 7.81474 4.89164 7.79881 4.89209 7.78323C4.91137 7.78029 4.93228 7.77695 4.95459 7.77347C5.4896 7.68959 6.5544 7.52632 7.66553 7.67191C8.22829 7.74649 9.19241 7.80166 10.3647 8.21194V8.21292C10.411 8.22966 10.4539 8.24616 10.4937 8.26077C10.3538 8.59904 10.1357 8.8126 9.99951 8.94534C9.55987 9.35934 9.32657 9.56772 9.20264 9.68069C9.16097 9.71868 9.12711 9.7535 9.1001 9.78128H8.95947L9.0083 10.0215C9.02812 10.1185 9.09679 10.1826 9.14404 10.2188C9.19716 10.2595 9.26304 10.2948 9.3335 10.3252C9.47566 10.3865 9.66801 10.4423 9.89502 10.4893C10.3512 10.5836 10.9756 10.647 11.688 10.6328C13.1113 10.6045 14.9132 10.2666 16.437 9.22269C16.8351 8.95031 17.6499 8.33018 18.4644 7.52151C19.276 6.71568 20.1045 5.70601 20.5073 4.65335L20.5083 4.65237C20.5447 4.55529 20.623 4.34198 20.7261 4.1553C20.778 4.06123 20.8306 3.98414 20.8794 3.9346C20.9109 3.90271 20.9299 3.89106 20.938 3.88773Z\" fill=\"#f7a855\" stroke=\"#f7a855\" stroke-width=\"0.4\"></path><path d=\"M1.40625 4.01465C3.53427 0.711274 7.67062 -0.644625 11.4121 0.736328C11.6937 0.839712 11.9673 0.956482 12.2285 1.09082L12.2305 1.0918C12.6268 1.29137 12.9272 1.44642 13.1592 1.58984C13.39 1.73256 13.5415 1.85657 13.6465 1.98926C13.664 2.01217 13.729 2.10121 13.8398 2.14062L13.8916 2.1543L13.9023 2.15625C14.0236 2.17152 14.1184 2.11694 14.1836 2.05762C14.244 2.00262 14.2966 1.92784 14.3438 1.85547C14.4459 1.69866 14.5528 1.50645 14.7324 1.26172C15.0659 0.807379 15.3075 0.638318 15.4629 0.551758L15.4678 0.548828C15.4835 0.539471 15.4998 0.532448 15.5146 0.524414L15.5537 0.579102C15.7224 0.825821 16.1573 1.47235 16.4551 2.3418L16.5732 2.72852C16.8077 3.60771 16.7875 4.35534 16.7461 5.7998V5.80469C16.7461 5.82089 16.7446 5.83709 16.7441 5.85254L16.6826 5.86328C16.1477 5.94714 15.0834 6.11024 13.9727 5.96484C13.4096 5.89018 12.4432 5.83399 11.2695 5.42285C11.2236 5.40622 11.1811 5.38952 11.1416 5.375C11.2813 5.0368 11.5005 4.82322 11.6367 4.69043L11.6377 4.69141C12.0781 4.27673 12.3117 4.06798 12.4355 3.95508C12.493 3.90272 12.5383 3.86066 12.5664 3.82715C12.5812 3.80949 12.6052 3.77809 12.6191 3.73535C12.6358 3.68402 12.6301 3.64 12.624 3.6123H12.6221C12.6006 3.51895 12.5354 3.4563 12.4893 3.4209C12.4362 3.3803 12.3701 3.34578 12.2998 3.31543C12.1577 3.25413 11.9662 3.19734 11.7393 3.15039C11.283 3.05603 10.658 2.99267 9.94531 3.00684C8.52197 3.03515 6.72013 3.37303 5.19629 4.41699C4.79819 4.68936 3.98343 5.30951 3.16895 6.11816C2.3573 6.924 1.52878 7.93366 1.12598 8.98633V8.9873C1.08959 9.08436 1.01043 9.29854 0.907227 9.48535C0.855339 9.57922 0.802618 9.65562 0.753906 9.70508C0.720376 9.73906 0.700455 9.74834 0.693359 9.75098C0.684344 9.74593 0.663079 9.73005 0.629883 9.68652C0.581067 9.62246 0.531496 9.52809 0.485352 9.41602C0.439507 9.30462 0.4005 9.18637 0.370117 9.08301L0.304688 8.83789C0.201999 8.42717 0.195001 8.08495 0.202148 7.85156V7.84961C0.223984 6.76231 0.518683 5.85332 0.756836 5.26758C0.888124 4.94499 1.04157 4.62975 1.21973 4.32129L1.40625 4.01465Z\" fill=\"#f7a855\" stroke=\"#f7a855\" stroke-width=\"0.4\"></path></svg>";
        var minusSvg    = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.75 8.1001H5.25C4.83525 8.1001 4.5 8.5033 4.5 9.0001C4.5 9.4969 4.83525 9.9001 5.25 9.9001H12.75C13.1648 9.9001 13.5 9.4969 13.5 9.0001C13.5 8.5033 13.1648 8.1001 12.75 8.1001Z\" fill=\"black\"/></svg>";
        var plusSvg     = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\"><path d=\"M5 0.5C4.58579 0.5 4.25 0.835786 4.25 1.25V4.25H1.25C0.835786 4.25 0.5 4.58579 0.5 5C0.5 5.41421 0.835786 5.75 1.25 5.75H4.25V8.75C4.25 9.16421 4.58579 9.5 5 9.5C5.41421 9.5 5.75 9.16421 5.75 8.75V5.75H8.75C9.16421 5.75 9.5 5.41421 9.5 5C9.5 4.58579 9.16421 4.25 8.75 4.25H5.75V1.25C5.75 0.835786 5.41421 0.5 5 0.5Z\" fill=\"black\"/></svg>";
        var autoshipButtonHTML =
        `
            <button class="autoship-add-to-cart ${ autoshipBtnClass }" data-product-id="${product.id}" data-variant-id="${variantId}" data-product-title="${product.title.replace( /"/g, "&quot;" )}" data-product-vendor="${product.vendor.replace( /"/g, "&quot;" )}" data-product-image="${product.featured_image || ""}" data-membership-variant-id="${membershipVariantId}" data-membership-selling-plan-id="${membershipSellingPlanId}" data-product-price="${priceFormatted}" data-compare-at-price="${comparePrice}">
                <span class="autoship-add-to">Add to ${autoshipSvg}<span class="autoship-name">Autoship</span></span>
            </button>
            <div class="pdp-autoship-qty hidden">
                <div class="autoship-qty-wrapper">
                    <button class="pdp-autoship-minus">${minusSvg}</button>
                    <span class="pdp-autoship-qty-count"></span>
                    <button class="pdp-autoship-plus">${plusSvg}</button>
                </div>
            </div>
        `;
        addToCartButton.insertAdjacentHTML( "afterend", autoshipButtonHTML );
        
        var autoshipButton = card.querySelector( ".autoship-add-to-cart" );
        if ( autoshipButton )
        {
            autoshipButton.addEventListener( "click", function HandleAutoshipButtonClick( e )
            {
                e.preventDefault( );
                autoshipButton.disabled = true;
                handleAutoshipAdd( e.currentTarget );
            });
            
            var autoshipQty = card.querySelector( ".pdp-autoship-qty" );
            if ( window._autoshipData )
            {
                var autoshipInfo = getRechargeLineInfo( window._autoshipData, product.id, variantId );
                if ( autoshipInfo && autoshipInfo.sid && autoshipInfo.qty > 0 )
                {
                    if ( autoshipQty )
                    {
                        autoshipButton.classList.add( "hidden" );
                        autoshipQty.classList.remove( "hidden" );
                        setupCollectionAutoshipQuantity( autoshipQty, autoshipInfo.sid, autoshipButton );
                        autoshipQty.querySelector( ".pdp-autoship-qty-count" ).innerText = AutoshipQtyString( autoshipInfo.qty );
                    }
                }
            }
        }
        
        ObserveSingleProductCard( card );
    }
}

function SetupECCardTags( card, product )
{
    var imageContainer = card.querySelector( ".ec-product-image-container" );
    if ( !imageContainer )
    {
        return;
    }

    imageContainer.style.position = "relative";

    var tagContainer = card.querySelector( ".product-card__tag-container" );
    if ( !tagContainer )
    {
        tagContainer = document.createElement( "div" );
        tagContainer.className = "product-card__tag-container";
        imageContainer.appendChild( tagContainer );
    }

    tagContainer.innerHTML = "";

    var templateTag = document.createElement( "span" );
    templateTag.className = "product-card__tag";

    var collectionsStr = product.collections || "";
    var tagsStr        = product.tags || "";

    var collections = collectionsStr ? collectionsStr.split( ";" ) : [];
    var tags        = tagsStr ? tagsStr.split( ";" ) : [];

    function AppendTag( className, text, html )
    {
        var tagEl = templateTag.cloneNode( true );

        if ( className )
        {
            tagEl.classList.add( className );
        }

        if ( html )
        {
            tagEl.innerHTML = html;
        }
        else
        {
            tagEl.textContent = text || "";
        }

        tagContainer.appendChild( tagEl );
    }

    if ( collections.includes( "New Lower Prices" ) )
    {
        AppendTag( "product-card__tag--new-sale", "New Lower Prices", "" );
    }

    if ( tags.includes( "New" ) )
    {
        AppendTag( "product-card__tag--new", "New", "" );
    }

    if ( tags.includes( "Clearance" ) )
    {
        AppendTag( "product-card__tag--clear", "Clearance", "" );
    }

    if ( tags.includes( "WellEasy Days 10%" ) )
    {
        AppendTag( "product-card__tag--wedays", "", 'WellEasy Days <span class="product-card__tag-badge">10%</span>' );
    }

    if ( tags.includes( "WellEasy Days 15%" ) )
    {
        AppendTag( "product-card__tag--wedays", "", 'WellEasy Days <span class="product-card__tag-badge">15%</span>' );
    }

    if ( tags.includes( "WellEasy Days 20%" ) )
    {
        AppendTag( "product-card__tag--wedays", "", 'WellEasy Days <span class="product-card__tag-badge">20%</span>' );
    }

    for ( var i = 0; i < tags.length; i++ )
    {
        var tag = tags[ i ];
        if ( !tag )
        {
            continue;
        }

        if ( tag.includes( "WellEasy Cash" ) || tag.includes( "4 for 3" ) )
        {
            var displayText = tag.split( "," )[ 0 ].trim( );
            var clipId      = "wec_clip_" + product.id + "_" + i;

            AppendTag(
                "product-card__tag--wec",
                "",
                `${displayText}
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" style="margin-left:3px;vertical-align:middle;">
                    <g clip-path="url(#${clipId})">
                        <rect width="17" height="16" rx="8" fill="white"></rect>
                        <path d="M8.5 0.25C13.0708 0.25 16.75 3.73386 16.75 8C16.75 12.2661 13.0708 15.75 8.5 15.75C3.92916 15.75 0.25 12.2661 0.25 8C0.25 3.73386 3.92916 0.25 8.5 0.25ZM11.6914 5.51172C11.6912 4.0372 10.3661 3.1356 8.96777 3.34473C7.55499 3.55525 6.5832 4.75836 6.58301 6.37793C6.58301 6.56942 6.57808 6.76037 6.57031 6.9502H6.4082C6.12184 6.9502 5.84305 7.05684 5.63574 7.25293C5.42928 7.44829 5.3086 7.71609 5.30859 8C5.30859 8.28236 5.4276 8.55057 5.63574 8.74609V8.74707C5.81892 8.92034 6.05786 9.0232 6.30859 9.04492C6.18113 9.65251 6.01376 10.2477 5.79688 10.8291C5.76312 10.9196 5.74212 11.0146 5.73535 11.1104L5.7334 11.2002C5.73345 11.4825 5.85246 11.7508 6.06055 11.9463V11.9473C6.26783 12.1433 6.54669 12.25 6.83301 12.25H10.2334C10.4839 12.2499 10.7287 12.1683 10.9248 12.0166L11.0059 11.9473C11.2138 11.7514 11.333 11.4833 11.333 11.2002C11.333 10.9173 11.2138 10.6478 11.0049 10.4521C10.7979 10.2583 10.5207 10.1505 10.2334 10.1504H8.30566C8.4007 9.78666 8.48064 9.41941 8.54688 9.0498H9.80859C10.0949 9.04969 10.3738 8.94314 10.5811 8.74707L10.5801 8.74609C10.7879 8.55018 10.9082 8.28308 10.9082 8C10.9082 7.71708 10.789 7.44757 10.5801 7.25195C10.3731 7.05819 10.0958 6.95031 9.80859 6.9502H8.77148C8.77847 6.76064 8.7832 6.56967 8.7832 6.37793C8.78327 6.03342 8.85755 5.80009 8.95508 5.65332C9.0495 5.51128 9.17177 5.43907 9.30664 5.41895H9.30762C9.41737 5.40256 9.46138 5.42497 9.4707 5.43164C9.47247 5.43271 9.49213 5.44498 9.49219 5.51172C9.49219 5.79421 9.61102 6.06324 9.81934 6.25879V6.25977C10.027 6.45523 10.305 6.56249 10.5918 6.5625C10.878 6.5625 11.156 6.45466 11.3633 6.25879L11.3643 6.25977C11.5725 6.0638 11.6914 5.79506 11.6914 5.51172Z" fill="#0EC4B9" stroke="black" stroke-width="0.5"></path>
                    </g>
                    <defs>
                        <clipPath id="${clipId}">
                            <rect width="17" height="16" rx="8" fill="white"></rect>
                        </clipPath>
                    </defs>
                </svg>`
            );

            var parts = tag.split( "," );
            for ( var p = 0; p < parts.length; p++ )
            {
                var singleTag = parts[ p ].trim( );
                if ( singleTag.includes( "Sale" ) && singleTag.includes( "%" ) )
                {
                    AppendTag( "product-card__tag--sale", singleTag, "" );
                }
            }
        }
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////
// EC qty + ATC swap logic (FULL BLOCK)
//////////////////////////////////////////////////////////////////////////////////////////////////////////

function EC_GetCartQtyForVariant( cart, variantId )
{
    var result = 0;

    if ( cart && cart.items && cart.items.length > 0 && variantId )
    {
        for ( var i = 0; i < cart.items.length; i++ )
        {
            if ( String( cart.items[ i ].variant_id ) == String( variantId ) )
            {
                result = cart.items[ i ].quantity || 0;
                break;
            }
        }
    }

    return result;
}

function EC_ShowAtcHideQty( card )
{
    var atc = null;

    if ( card )
    {
        atc = card.querySelector( ".ec-add-to-cart" );
    }

    if ( atc )
    {
        atc.style.display = "";
        atc._has_been_swapped_for_qty_controls = false;
    }

    if ( card && card._qtyControls )
    {
        card._qtyControls.remove( );
        card._qtyControls = null;
    }
}

function EC_ShowQtyHideAtc( card, qty )
{
    var addToCartButton = null;
    var variantId       = "";
    var wrapper         = null;

    if ( card )
    {
        addToCartButton = card.querySelector( ".ec-add-to-cart" );
        variantId       = card.getAttribute( "data-variant-id" ) || "";
    }

    if ( !addToCartButton || !variantId )
    {
        return;
    }

    addToCartButton._has_been_swapped_for_qty_controls = true;
    addToCartButton.style.display = "none";

    if ( card._qtyControls )
    {
        card._qtyControls.remove( );
        card._qtyControls = null;
    }

    wrapper = document.createElement( "div" );
    wrapper.innerHTML =
    `
        <quantity-input class="quantity quantity-wrapper" data-item-in-cart="true" data-variant-id="${variantId}">
            <button class="quantity__button no-js-hidden" name="minus" type="button">
                <span class="visually-hidden">Quantity</span>
                <svg class="icon icon-minus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M400 288h-352c-17.69 0-32-14.32-32-32.01s14.31-31.99 32-31.99h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z"></path>
                </svg>
            </button>
            <input class="quantity__input" type="number" name="quantity" data-cart-quantity="${qty}" data-min="1" min="1" step="1" value="${qty}">
            <button class="quantity__button no-js-hidden" name="plus" type="button">
                <span class="visually-hidden">Quantity</span>
                <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z"></path>
                </svg>
            </button>
        </quantity-input>
    `;

    card._qtyControls = wrapper.querySelector( "quantity-input" );
    addToCartButton.parentNode.appendChild( card._qtyControls );

    EC_BindQtyControlsForCard( card );
}

function EC_NotifyCartUpdated( cart )
{
    document.dispatchEvent(
        new CustomEvent(
            "enhancedcommerce:cart_updated",
            {
                "detail": { "cart": cart }
            }
        )
    );

    // common theme patterns (safe if nothing listens)
    document.dispatchEvent( new CustomEvent( "cart:updated", { "detail": { "cart": cart } } ) );
    document.dispatchEvent( new CustomEvent( "cart:refresh", { "detail": { "cart": cart } } ) );
}

function EC_BindCartUpdatedRefresh( )
{
    if ( document._ecCartUpdatedBound )
    {
        return;
    }

    document._ecCartUpdatedBound = true;

    document.addEventListener( "enhancedcommerce:cart_updated", function EC_OnCartUpdated( e )
    {
        var cards = document.querySelectorAll( ".product-grid__product-card[data-variant-id]" );
        for ( var i = 0; i < cards.length; i++ )
        {
            EC_UpdateQtyControlsForCard( cards[ i ] );
        }
    } );
}

function EC_SetCartQty( variantId, qty, callback )
{
    function OnJson( data )
    {
        callback( null, data );
    }

    function OnOk( r )
    {
        r.json( ).then( OnJson ).catch( OnErr );
    }

    function OnErr( err )
    {
        callback( err, null );
    }

    fetch(
        "/cart/change.js",
        {
            "method": "POST",
            "headers": { "Content-Type": "application/json" },
            "credentials": "same-origin",
            "body": JSON.stringify( { "id": variantId, "quantity": qty } )
        }
    )
    .then( OnOk )
    .catch( OnErr );
}

function EC_AddToCartOne( variantId, callback )
{
    function OnJson( data )
    {
        callback( null, data );
    }

    function OnOk( r )
    {
        r.json( ).then( OnJson ).catch( OnErr );
    }

    function OnErr( err )
    {
        callback( err, null );
    }

    fetch(
        "/cart/add.js",
        {
            "method": "POST",
            "headers": { "Content-Type": "application/json" },
            "credentials": "same-origin",
            "body": JSON.stringify( { "items": [ { "id": variantId, "quantity": 1 } ] } )
        }
    )
    .then( OnOk )
    .catch( OnErr );
}

async function EC_UpdateQtyControlsForCard( card )
{
    var addToCartButton = null;
    var variantId       = "";
    var cart            = null;
    var qty             = 0;

    if ( card )
    {
        addToCartButton = card.querySelector( ".ec-add-to-cart" );
        variantId       = card.getAttribute( "data-variant-id" ) || "";
    }

    if ( addToCartButton && variantId )
    {
        try
        {
            cart = await fetch( "/cart.js", { "credentials": "same-origin" } ).then( function EC_CartJson( r ){ return r.json( ); } );
        }
        catch ( e )
        {
            console.log( "EC_UpdateQtyControlsForCard cart fetch failed", e );
        }

        qty = EC_GetCartQtyForVariant( cart, variantId );

        if ( qty > 0 )
        {
            EC_ShowQtyHideAtc( card, qty );
        }
        else if ( addToCartButton._has_been_swapped_for_qty_controls )
        {
            EC_ShowAtcHideQty( card );
        }
    }
}

function EC_BindQtyControlsForCard( card )
{
    var qtyRoot  = null;
    var minus    = null;
    var plus     = null;
    var input    = null;
    var variantId = "";
    var atc      = null;

    if ( card )
    {
        qtyRoot   = card._qtyControls;
        variantId = card.getAttribute( "data-variant-id" ) || "";
        atc       = card.querySelector( ".ec-add-to-cart" );
    }

    if ( !qtyRoot || !variantId )
    {
        return;
    }

    if ( qtyRoot._ecBound )
    {
        return;
    }

    qtyRoot._ecBound = true;

    minus = qtyRoot.querySelector( "button[name='minus']" );
    plus  = qtyRoot.querySelector( "button[name='plus']" );
    input = qtyRoot.querySelector( "input.quantity__input" );

    function GetCurrentQty( )
    {
        var val = 0;

        if ( input && input.value != null && input.value != "" && !isNaN( Number( input.value ) ) )
        {
            val = Number( input.value );
        }
        else if ( input )
        {
            var attr = input.getAttribute( "data-cart-quantity" );
            if ( attr != null && attr != "" && !isNaN( Number( attr ) ) )
            {
                val = Number( attr );
            }
        }

        return val;
    }

    function ApplyQtyToInput( newQty )
    {
        if ( input )
        {
            input.value = String( newQty );
            input.setAttribute( "data-cart-quantity", String( newQty ) );
        }
    }

    function OnSetComplete( err, cart, newQty )
    {
        if ( err )
        {
            return;
        }

        EC_NotifyCartUpdated( cart );

        if ( newQty <= 0 )
        {
            EC_ShowAtcHideQty( card );
        }
        else
        {
            ApplyQtyToInput( newQty );
        }
    }

    function HandleMinusClick( e )
    {
        e.preventDefault( );

        var currentQty = GetCurrentQty( );
        var nextQty    = currentQty - 1;

        if ( nextQty < 0 )
        {
            nextQty = 0;
        }

        if ( minus )
        {
            minus.disabled = true;
        }

        function OnQtySet( err, cart )
        {
            if ( minus )
            {
                minus.disabled = false;
            }

            OnSetComplete( err, cart, nextQty );
        }

        EC_SetCartQty( variantId, nextQty, OnQtySet );
    }

    function HandlePlusClick( e )
    {
        e.preventDefault( );

        var currentQty = GetCurrentQty( );
        var nextQty    = currentQty + 1;

        if ( plus )
        {
            plus.disabled = true;
        }

        function OnQtySet( err, cart )
        {
            if ( plus )
            {
                plus.disabled = false;
            }

            OnSetComplete( err, cart, nextQty );
        }

        EC_SetCartQty( variantId, nextQty, OnQtySet );
    }

    if ( minus )
    {
        minus.addEventListener( "click", HandleMinusClick );
    }

    if ( plus )
    {
        plus.addEventListener( "click", HandlePlusClick );
    }

    if ( atc && !atc._ecQtyBound )
    {
        atc._ecQtyBound = true;

        atc.addEventListener( "click", function EC_AtcSwapToQty( e )
        {
            var vid = variantId;

            atc.setAttribute( "disabled", "disabled" );

            function OnAdded( err, cart )
            {
                atc.removeAttribute( "disabled" );

                if ( err )
                {
                    return;
                }

                EC_NotifyCartUpdated( cart );
                EC_UpdateQtyControlsForCard( card );
            }

            EC_AddToCartOne( vid, OnAdded );
        } );
    }
}

window.addEventListener( "enhancedcommerce:card_rendered", async function HandleEnhancedCommerceCardRendered( e )
{
    var detail          = e.detail;
    var product         = detail.product;
    var card            = detail.card;
    fetch( `/products/${product.handle}.js` )
    .then( response =>
    {
        if ( !response.ok )
        {
            console.warn( response.statusText );
        }
        return response.json( );
    })
    .then( response =>
    {
        var firstVariant = response.variants.filter( variant => variant.id == product.variants[ 0 ].id )[ 0 ];
        var variantId       = firstVariant.id;
        var hasAutoship     = firstVariant.selling_plan_allocations && firstVariant.selling_plan_allocations.length > 0;
        var priceFormatted  = ( firstVariant.price / 100 ).toFixed( 2 ) + " GBP";
        var comparePrice    = priceFormatted;

        if ( firstVariant.compare_at_price )
        {
            comparePrice = ( firstVariant.compare_at_price / 100 ).toFixed( 2 ) + " GBP";
        }

        //EC_BindCartUpdatedRefresh( );

        SetupECCardLinks( card, product );
        SetupECCardBrandReview( card, product );
        SetupECCardDiscount( card, firstVariant );
        SetupECCardTags( card, product );
        SetupECCardAttributes( card, product, variantId, firstVariant );

        SetupECCardPrices( card, product, firstVariant, hasAutoship );
        SetupECCardOnetimeButton( card, product, firstVariant );
        SetupECCardAutoshipButton( card, product, variantId, firstVariant, hasAutoship, priceFormatted, comparePrice );

        document.dispatchEvent( new CustomEvent( "enhancedcommerce:card_prices_ready", { "detail": { "card": card } } ) );

        //EC_UpdateQtyControlsForCard( card );
        //EC_BindQtyControlsForCard( card )
    });

    updateGridSection( );
} );

function createAccountWellEasyQuiz( )
{
    var isQuizFlow = false;
    var form       = null;

    var flow = null;
    try { flow = sessionStorage.getItem('we_register_flow'); } catch (e) {}
    isQuizFlow = ( window.location.pathname == "/account/register" && ( flow == "quiz" || window.location.search == "?flow=quiz" ) );

    if ( isQuizFlow )
    {
        form = document.querySelector( "form" );
        if ( form )
        {
            form.addEventListener( "submit", createAccountWellEasyQuiz_OnSubmit );
        }
    }
}

function createAccountWellEasyQuiz_OnSubmit( e )
{
    return;
}

document.addEventListener( "DOMContentLoaded", createAccountWellEasyQuiz );

function WE_IsMembershipProduct( productId )
{
    const s   = ( theme && theme.settings ) || ( window.themeSettings || {} );
    const pid = parseInt( productId, 10 );
    var out   = false;

    if ( s.annual_subscription_product && pid == ( s.annual_subscription_product.id || s.annual_subscription_product ) )
    {
        out = true;
    }
    else if ( s.monthly_subscription_product && pid == ( s.monthly_subscription_product.id || s.monthly_subscription_product ) )
    {
        out = true;
    }
    else if ( s.legacy_annual_subscription_product && pid == ( s.legacy_annual_subscription_product.id || s.legacy_annual_subscription_product ) )
    {
        out = true;
    }
    return out;
}

function WE_CartHasMembership( cart )
{
    var i   = 0;
    var out = false;

    if ( cart && cart.items )
    {
        for ( i = 0; i < cart.items.length; i++ )
        {
            if ( WE_IsMembershipProduct( cart.items[ i ].product_id ) )
            {
                out = true;
                break;
            }
        }
    }
    return out;
}

function WE_GetCartMembershipItems( cart )
{
    const out = [];
    var i     = 0;
    var it    = null;

    if ( cart && cart.items )
    {
        for ( i = 0; i < cart.items.length; i++ )
        {
            it = cart.items[ i ];
            if ( WE_IsMembershipProduct( it.product_id ) )
            {
                out.push( { key: it.key, index: i + 1, quantity: it.quantity, variantId: it.variant_id } );
            }
        }
    }
    return out;
}

function WE_FixDuplicateMembershipInCart_ParseJson( r )
{
    return r.json();
}

function WE_FixDuplicateMembershipInCart_OnCart( cart )
{
    const memberships = WE_GetCartMembershipItems( cart );
    var totalQty      = 0;
    const updates     = {};
    var kept          = false;
    var i             = 0;
    var m             = null;
    var result        = { done: true, cart: cart };

    for ( i = 0; i < memberships.length; i++ )
    {
        totalQty += memberships[ i ].quantity;
    }
    if ( totalQty > 1 || memberships.length > 1 )
    {
        for ( i = 0; i < memberships.length; i++ )
        {
            m = memberships[ i ];
            if ( !kept )
            {
                if ( m.quantity > 1 )
                {
                    updates[ String( m.variantId ) ] = 1;
                }
                kept = true;
            }
            else
            {
                updates[ String( m.variantId ) ] = 0;
            }
        }
        if ( Object.keys( updates ).length > 0 )
        {
            result = { done: false, updates: updates };
        }
    }
    return result;
}

function WE_FixDuplicateMembershipInCart_OnUpdated( callback, updated )
{
    if ( callback )
    {
        callback( null, updated );
    }
    document.dispatchEvent( new CustomEvent( "cart_item_added" ) );
}

function WE_FixDuplicateMembershipInCart_OnErr( callback, err )
{
    if ( callback )
    {
        callback( err, null );
    }
}

function WE_FixDuplicateMembershipInCart( callback )
{
    fetch( "/cart.js", { credentials: "same-origin" } )
        .then( WE_FixDuplicateMembershipInCart_ParseJson )
        .then( function WE_FixDuplicateMembershipInCart_ThenCart( cart )
        {
            return WE_FixDuplicateMembershipInCart_AsyncStep( callback, cart );
        } )
        .catch( function WE_FixDuplicateMembershipInCart_Catch( err )
        {
            WE_FixDuplicateMembershipInCart_OnErr( callback, err );
        } );
}

function WE_FixDuplicateMembershipInCart_AsyncStep( callback, cart )
{
    const result = WE_FixDuplicateMembershipInCart_OnCart( cart );
    var next     = null;

    if ( result.done )
    {
        if ( callback )
        {
            callback( null, result.cart );
        }
    }
    else
    {
        next = fetch( "/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify( { updates: result.updates } )
        } )
            .then( WE_FixDuplicateMembershipInCart_ParseJson )
            .then( function WE_FixDuplicateMembershipInCart_ThenUpdated( updated )
            {
                WE_FixDuplicateMembershipInCart_OnUpdated( callback, updated );
            } );
    }
    return next;
}

function WE_MembershipFixDomReady( )
{
    setTimeout( WE_FixDuplicateMembershipInCart, 800 );
    if ( window.location.pathname == "/cart" )
    {
        setTimeout( WE_FixDuplicateMembershipInCart, 2500 );
    }
}

document.addEventListener( "DOMContentLoaded", WE_MembershipFixDomReady );



///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  widget tests
//
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function ItsAPrimitiveType( value )
{
    var primitive = false;

    if ( ( typeof( value ) == "string" ) || ( typeof( value ) == "number" )|| ( typeof( value ) == "boolean" ) || ( value == null ) )
    {
        primitive = true;
    }
    else if ( ( value instanceof Date ) || ( value instanceof String ) || ( value instanceof Number ) || ( value instanceof Boolean ) )
    {
        primitive = true;
    }

    return ( primitive );
}


function ObjectsMatch( reference, check, key )
{
    var matching = { "same" : true, "message" : "", "mismatches" : [] };

    if ( !key )
    {
        key = "root";
    }
    if ( ( reference != undefined ) && ( check != undefined ) )
    {
        if ( ItsAPrimitiveType( reference ) )
        {
            matching.same = reference.toString( ) === check.toString( );

            if ( !matching.same )
            {
                matching.message = `object primitive match failed for '${key}' - ref val '${reference}' not matched to check val '${check}'`;
                console.log( matching.message );
            }
        }
        else if ( reference instanceof Array )
        {
            if ( ( check instanceof Array ) && ( reference.length == check.length ) )
            {
                for ( var i = 0; i < reference.length; i++ )
                {
                    let subMatch = ObjectsMatch( reference[ i ], check[ i ], key + "[" + i + "]" );
                    if ( !subMatch.same )
                    {
                        matching.same = false;
                        break;
                    }
                }
            }
            else
            {
                if ( check instanceof Array )
                {
                    matching.message = `object match failed (array mismatch, reference length ${reference.length} and check length ${check.length} for key ${key})`;
                }
                else
                {
                    matching.message = `object match failed (array mismatch, reference is array of length ${reference.length} and check is ${check.toString( )} for key ${key})`;
                }
                matching.same = false;
                console.log( matching.message );
            }
        }
        else
        {
            for ( var member in reference )
            {
                var memberKey = key + "." + member;
                if ( check[ member ] === undefined )
                {
                    var msg = `object match failed - key '${memberKey}' missing from check data`;
                    matching.same = false;
                    console.log( matching.message );
                    break;
                }
                else
                {
                    let subMatch = ObjectsMatch( reference[ member ], check[ member ], memberKey );
                    if ( !subMatch.same )
                    {
                        matching.same = false;
                        break;
                    }
                }
            }
        }
    }
    else if ( reference )
    {
        matching.message = `object match failed missing member '${key}' in check data`;
        matching.same = false;
    }
    else if ( check )
    {
        matching.message = `object match failed missing member '${key}' in reference data`;
        matching.same = false;
    }

    return ( matching );
}


function TEST_SendAPIRequest( url, method, params, cb )
{
    var xhr = new XMLHttpRequest( );   

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            //console.log( "rx response " + xhr.responseText );
            if ( cb )
            {
                var parsed;

                var ct = xhr.getResponseHeader( "Content-Type" );
                if ( ( ct ) && ( ct.indexOf( "json" ) >= 0 ) && ( xhr.responseText ) )
                {
                    try
                    {
                        parsed = JSON.parse( xhr.responseText );
                    }
                    catch ( e )
                    {
                        console.log( "error parsing JSON response : " + e.stack );
                    }
                }

                cb( xhr, parsed );
            }
            else
            {
                if ( xhr.status == 200 )
                {
                    window.location.reload( );
                }
            }
        }
    };

    //console.log( "requesting " + method + " from " + url );
    if ( params )
    {
        xhr.open( method, url, true );
        xhr.setRequestHeader( "Content-Type", "application/json" );
        xhr.setRequestHeader( "x-store", "welleasy.myshopify.com" );
        xhr.send( JSON.stringify( params ) );
    }
    else
    {
        xhr.open( method, url, true );
        xhr.setRequestHeader( "x-store", "welleasy.myshopify.com" );
        xhr.send( );
    }
}

function ReallyRunWidgetTests( payload, count, interval, cb )
{
    var i = 0;
    var result = { "responses" : [ ], "matches" : 0, "misses" : 0 };
    function NextTest( )
    {
        if ( i < count )
        {
            //TEST_SendAPIRequest( "https://app.enhanced-commerce.com/api/v3/ec-execute", "POST", payload, function( err, response )
            TEST_SendAPIRequest( "https://enhanced-commerce-test.lightning-e.com/api/v3/ec-execute", "POST", payload, function( err, response )
            {
                if ( result.responses.length > 0 )
                {
                    for ( var j = 0; j < result.responses.length; j++ )
                    {
                        var match = ObjectsMatch( response, result.responses[ j ] );
                        
                        if ( match.same )
                        {
                            result.matches++;
                        }
                        else
                        {
                            result.misses++;
                        }
                    }
                }
                result.responses.push( response );

                setTimeout( function( )
                {
                    i++;
                    NextTest( );
                    
                }, interval );
            } );
        }
        else
        {
            cb( result );
        }
    }
    NextTest( );
}

function RunWidgetTests( numTests = 10, interval = 1000)
{
    console.log( "****************************************************** running tests ****************************************************** " );
    var payload = {"c":[{"command":"getWidget","widgetType":"custom","widgetName":"quiz results","target":".ec-widget-1774129664941-20066878693374757 .enhanced-commerce-widget-content","brandLimit":3,"defaultVendorLimit":2,"vendorLimits":{"WELLEASY":3},"pageType":"page"}],"s":"khEUzmzNwXaNBhosGymwhvL9aETqjrmHi3yymkmX5n9KyNIOeF1X7w2w4QoLxGpvIhkcikICgC4wTXDEUK72Sgxx"};
    
    ReallyRunWidgetTests( payload, numTests, interval, function( result )
    {
        console.log( "****************************************************** tests complete ****************************************************** " );
        console.log( "test complete : ", result );
    } );
}

console.log( "tests available" );

//RunWidgetTests( );
